/**
 * Turkish catalog and the catalog types. `tr` is the source of truth for keys; every other locale must provide the
 * same keys (enforced by the type and by a test). Plural forms use Intl.PluralRules categories.
 */

export type PluralForms = Partial<Record<Intl.LDMLPluralRule, string>> & { other: string };
export type Entry = string | PluralForms;

export const tr = {
  'app.loading': 'Yükleniyor…',
  'nav.messages': 'Mesajlar',
  'nav.calls': 'Aramalar',
  'nav.spaces': 'Alanlar',
  'nav.discover': 'Keşfet',
  'nav.ai': 'Yapay Zekâ',
  'nav.settings': 'Ayarlar',
  'auth.login.title': 'Giriş yap',
  'auth.register.title': 'Hesap oluştur',
  'auth.identifier': 'E-posta veya kullanıcı adı',
  'auth.email': 'E-posta',
  'auth.username': 'Kullanıcı adı',
  'auth.password': 'Parola',
  'auth.passwordHint': 'En az 10 karakter',
  'auth.displayName': 'Görünen ad',
  'auth.birthDate': 'Doğum tarihi',
  'auth.birthDateHint': 'Yaşına uygun güvenlik ayarlarını belirlemek için kullanılır; profilinde gösterilmez.',
  'auth.day': 'Gün',
  'auth.month': 'Ay',
  'auth.year': 'Yıl',
  'auth.country': 'Ülke',
  'auth.acceptTerms': 'Kullanım koşullarını ve gizlilik bildirimini okudum, kabul ediyorum.',
  'auth.submitLogin': 'Giriş yap',
  'auth.submitRegister': 'Hesap oluştur',
  'auth.noAccount': 'Hesabın yok mu?',
  'auth.haveAccount': 'Zaten hesabın var mı?',
  'auth.logout': 'Çıkış yap',
  'auth.or': 'veya',
  'auth.forgotLink': 'Parolamı unuttum',
  'auth.forgot.title': 'Parolanı sıfırla',
  'auth.forgot.body': 'Hesabının e-posta adresini yaz. Bir hesap varsa sıfırlama bağlantısı göndereceğiz.',
  'auth.forgot.submit': 'Bağlantı gönder',
  'auth.forgot.sent': 'Bu adrese kayıtlı bir hesap varsa sıfırlama bağlantısı gönderildi. Bağlantı 30 dakika geçerli.',
  'auth.reset.title': 'Yeni parola belirle',
  'auth.reset.newPassword': 'Yeni parola',
  'auth.reset.submit': 'Parolayı değiştir',
  'auth.reset.done': 'Parolan değiştirildi ve tüm cihazlardaki oturumlar kapatıldı. Yeni parolanla giriş yapabilirsin.',
  'auth.verify.title': 'E-posta doğrulama',
  'auth.verify.working': 'Doğrulanıyor…',
  'auth.verify.success': 'E-posta adresin doğrulandı.',
  'auth.verify.continue': 'Uygulamaya dön',
  'auth.passkey.login': 'Passkey ile giriş yap',
  'auth.passkey.unsupported': 'Bu tarayıcı passkey desteklemiyor.',
  'auth.passkey.cancelled': 'Passkey işlemi iptal edildi.',
  'banner.emailUnverified': 'E-posta adresini doğrula: {email}',
  'banner.resend': 'Bağlantıyı tekrar gönder',
  'banner.resent': 'Doğrulama bağlantısı gönderildi.',
  'passkeys.title': 'Passkey’ler',
  'passkeys.body': 'Parola yerine cihazının kilidiyle (parmak izi, yüz, PIN) giriş yap.',
  'passkeys.add': 'Passkey ekle',
  'passkeys.empty': 'Henüz passkey eklemedin.',
  'passkeys.created': 'Eklendi: {date}',
  'passkeys.lastUsed': 'Son kullanım: {date}',
  'passkeys.remove': 'Kaldır',
  'passkeys.added': 'Passkey eklendi.',
  'passkeys.synced': 'Senkronize',
  'mail.verify.subject': '{brand}: e-posta adresini doğrula',
  'mail.verify.body': 'Merhaba {name},\n\n{brand} hesabının e-posta adresini doğrulamak için aşağıdaki bağlantıyı kullan. Bağlantı 24 saat geçerli.',
  'mail.verify.cta': 'E-postamı doğrula',
  'mail.reset.subject': '{brand}: parola sıfırlama',
  'mail.reset.body': 'Merhaba {name},\n\nParolanı sıfırlamak için aşağıdaki bağlantıyı kullan. Bağlantı 30 dakika geçerli ve tek kullanımlık. Bu isteği sen yapmadıysan bu e-postayı yok sayabilirsin; parolan değişmez.',
  'mail.reset.cta': 'Parolamı sıfırla',
  'mail.passwordChanged.subject': '{brand}: parolan değiştirildi',
  'mail.passwordChanged.body': 'Merhaba {name},\n\n{brand} hesabının parolası az önce değiştirildi ve tüm cihazlardaki oturumlar kapatıldı. Bunu sen yapmadıysan hemen destek ekibiyle iletişime geç.',
  'mail.passwordChanged.cta': 'Giriş yap',
  'mail.test.subject': '{brand}: test e-postası',
  'mail.test.body': 'Merhaba {name},\n\nBu, {brand} yönetim panelinden gönderilen bir test e-postasıdır. Bunu okuyabiliyorsan e-posta gönderimi çalışıyor.',
  'mail.test.cta': 'Paneli aç',
  'mail.footer': 'Bu e-posta {brand} hesabınla ilgili bir işlem nedeniyle otomatik gönderildi.',
  'chat.title': 'Sohbetler',
  'chat.search': 'Sohbetlerde ara',
  'chat.new': 'Yeni sohbet',
  'chat.empty': 'Henüz sohbetin yok. Kişiler bölümünden @kullanıcıadı ile birini ekleyip sohbet başlat.',
  'chat.select': 'Bir sohbet seç',
  'chat.selectBody': 'Soldaki listeden bir sohbet seç ya da yeni bir sohbet başlat.',
  'chat.placeholder': 'Mesaj yaz',
  'chat.send': 'Gönder',
  'chat.typing': '{name} yazıyor…',
  'chat.loadOlder': 'Önceki mesajları yükle',
  'chat.today': 'Bugün',
  'chat.yesterday': 'Dün',
  'chat.you': 'Sen',
  'chat.noMessages': 'Henüz mesaj yok. İlk mesajı sen yaz.',
  'chat.status.queued': 'Gönderilmeyi bekliyor',
  'chat.status.sending': 'Gönderiliyor',
  'chat.status.sent': 'Gönderildi',
  'chat.status.delivered': 'İletildi',
  'chat.status.read': 'Okundu',
  'chat.status.failed': 'Gönderilemedi',
  'chat.retry': 'Tekrar dene',
  'chat.discard': 'Sil',
  'chat.cannotSend': 'Bu kişiye şu an mesaj gönderemezsin.',
  'chat.waitForReply': 'Bu kişi seni kişilerine eklediğinde ya da sana yazdığında cevap verebilirsin.',
  'chat.verifyToSend': 'Mesaj göndermek için önce e-posta adresini doğrula.',
  'chat.restrictedToSend': 'Mesajlaşma veli/vasi onayı tamamlandığında açılır.',
  'chat.encryptionNotice': 'Mesajlar sunucuya şifreli bağlantıyla (TLS) iletilir ve sunucuda saklanır. Uçtan uca şifreleme henüz yok.',
  'chat.unread': { one: '{count} okunmamış mesaj', other: '{count} okunmamış mesaj' },
  'chat.back': 'Sohbetlere dön',
  'contacts.title': 'Kişiler',
  'contacts.add': 'Ekle',
  'contacts.addLabel': 'Kullanıcı adıyla kişi ekle',
  'contacts.usernamePlaceholder': '@kullanıcıadı',
  'contacts.added': '{name} kişilerine eklendi.',
  'contacts.empty': 'Henüz kişin yok.',
  'contacts.message': 'Mesaj',
  'contacts.block': 'Engelle',
  'contacts.unblock': 'Engeli kaldır',
  'contacts.blocked': 'Engellendi',
  'contacts.hint': 'Birini eklemek onun sana yazabilmesini sağlar. Sen ona yazabilmek için onun da seni eklemesi ya da herkesten mesaj kabul etmesi gerekir.',
  'push.newMessage': 'Yeni mesaj',
  'push.newMessageHidden': 'Yeni bir mesajın var',
  'notifications.title': 'Bildirimler',
  'notifications.body': 'Uygulama kapalıyken yeni mesajlardan haberdar ol.',
  'notifications.enable': 'Bu cihazda bildirimleri aç',
  'notifications.disable': 'Bu cihazda kapat',
  'notifications.enabled': 'Bu cihazda bildirimler açık.',
  'notifications.denied': 'Tarayıcı bildirim iznini engelledi. İzni tarayıcının site ayarlarından açabilirsin.',
  'notifications.unsupported': 'Bu tarayıcı web bildirimlerini desteklemiyor.',
  'notifications.unavailable': 'Bildirimler şu an kullanılamıyor.',
  'notifications.preview': 'Bildirimde göster',
  'notifications.preview.full': 'Gönderen ve mesaj',
  'notifications.preview.sender': 'Yalnız gönderen',
  'notifications.preview.hidden': 'Hiçbir ayrıntı',
  'notifications.previewHint': 'Mesaj metni bildirim servisine şifreli iletilir ama kilit ekranında görünebilir.',
  'mute.label': 'Sessize al',
  'mute.1h': '1 saat',
  'mute.8h': '8 saat',
  'mute.1w': '1 hafta',
  'mute.forever': 'Her zaman',
  'mute.off': 'Sessizi kaldır',
  'mute.active': 'Sessizde',
  'report.message': 'Bildir',
  'report.user': 'Kullanıcıyı bildir',
  'report.title': 'Bildir',
  'report.reason': 'Neden bildiriyorsun?',
  'report.reason.spam': 'Spam veya istenmeyen mesaj',
  'report.reason.harassment': 'Taciz veya zorbalık',
  'report.reason.hate': 'Nefret söylemi',
  'report.reason.sexual_content': 'Cinsel içerik',
  'report.reason.child_safety': 'Bir çocuğun güvenliği risk altında',
  'report.reason.self_harm': 'Kendine zarar verme',
  'report.reason.violence': 'Şiddet veya tehdit',
  'report.reason.impersonation': 'Başkasının kimliğine bürünme',
  'report.reason.scam': 'Dolandırıcılık',
  'report.reason.other': 'Diğer',
  'report.details': 'Eklemek istediğin bilgi (isteğe bağlı)',
  'report.includeRecent': { one: 'Son {count} mesajı kanıt olarak ekle', other: 'Son {count} mesajı kanıt olarak ekle' },
  'report.evidenceNote': 'Yalnızca bildirdiğin mesaj ve eklemeyi seçtiğin mesajlar inceleme ekibiyle paylaşılır.',
  'report.alsoBlock': 'Bu kişiyi engelle',
  'report.submit': 'Bildirimi gönder',
  'report.sent': 'Teşekkürler. Bildirimin alındı ve incelenecek.',
  'report.emergency': 'Biri şu an tehlikedeyse hemen 112 Acil Çağrı Merkezi’ni ara.',
  'common.close': 'Kapat',
  'admin.nav': 'Yönetim',
  'admin.title': 'Yönetim',
  'admin.passkeyRequired': 'Yönetici işlemleri yalnız passkey ile açılmış ve 12 saatten yeni bir oturumda çalışır. Çıkış yapıp “Passkey ile giriş yap” ile tekrar gir.',
  'admin.roles': 'Rollerin: {roles}',
  'admin.tab.users': 'Kullanıcılar',
  'admin.tab.reports': 'Raporlar',
  'admin.tab.invites': 'Davetler',
  'admin.search': 'Kullanıcı adı, e-posta veya kimlik',
  'admin.state.active': 'Aktif',
  'admin.state.restricted': 'Kısıtlı',
  'admin.state.suspended': 'Askıda',
  'admin.suspend': 'Askıya al',
  'admin.unsuspend': 'Askıdan çıkar',
  'admin.suspendReason': 'Askıya alma nedeni (kayda geçer)',
  'admin.noResults': 'Sonuç yok.',
  'admin.reports.empty': 'Bekleyen rapor yok.',
  'admin.reports.priority': 'Öncelik {priority}',
  'admin.reports.evidence': 'Kanıt',
  'admin.reports.note': 'Karar notu (kayda geçer)',
  'admin.reports.action': 'İşlem yapıldı',
  'admin.reports.dismiss': 'Reddet',
  'admin.invites.create': 'Kod üret',
  'admin.invites.count': 'Adet',
  'admin.invites.note': 'Not',
  'admin.invites.newCodes': 'Yeni kodlar (yalnız şimdi gösterilir):',
  'admin.invites.used': '{used}/{max} kullanıldı',
  'admin.invites.revoke': 'İptal et',
  'admin.invites.revoked': 'İptal edildi',
  'conn.connected': 'Bağlı',
  'conn.reconnecting': 'Yeniden bağlanıyor…',
  'onboarding.title': 'DijitalApp’i nasıl kullanacaksın?',
  'onboarding.subtitle': 'Ana ekranını buna göre hazırlarız. İstediğin zaman değiştirebilirsin.',
  'onboarding.continue': 'Devam et',
  'onboarding.skip': 'Şimdilik atla',
  'onboarding.personaNote': 'Mod seçimi yalnızca görünümü değiştirir; yetki veya rol vermez.',
  'shell.activeSpace': 'Etkin alan',
  'shell.minorNotice': 'Hesabın yaşına uygun korumalı ayarlarla çalışıyor.',
  'shell.guardianPending': 'Bazı özellikler veli/vasi onayı tamamlanana kadar kapalı.',
  'module.disabled.title': 'Bu bölüm henüz açık değil',
  'module.disabled.body': '{module} geliştirme aşamasında ve şu an kapalı. Hazır olduğunda burada göreceksin.',
  'spaces.title': 'Alanlarım',
  'spaces.create': 'Yeni alan',
  'spaces.name': 'Alan adı',
  'spaces.type': 'Alan türü',
  'spaces.members': { one: '{count} üye', other: '{count} üye' },
  'spaces.type.personal': 'Kişisel',
  'spaces.type.family': 'Aile',
  'spaces.type.community': 'Topluluk',
  'spaces.type.school': 'Eğitim',
  'spaces.type.business': 'İş',
  'spaces.type.event': 'Etkinlik',
  'spaces.verificationRequired': 'Eğitim ve iş alanları kurum doğrulaması gerektirir.',
  'spaces.persona': 'Bu alandaki mod',
  'settings.title': 'Ayarlar',
  'settings.devices': 'Cihazlar',
  'settings.privacy': 'Gizlilik',
  'settings.appearance': 'Görünüm',
  'settings.theme.light': 'Açık',
  'settings.theme.dark': 'Koyu',
  'settings.theme.system': 'Sistem',
  'settings.language': 'Dil',
  'devices.current': 'Bu cihaz',
  'devices.lastActive': 'Son etkinlik: {date}',
  'devices.firstSeen': 'İlk giriş: {date}',
  'devices.signOut': 'Oturumu kapat',
  'devices.signOutOthers': 'Diğer tüm cihazlardan çıkış yap',
  'devices.count': { one: '{count} etkin cihaz', other: '{count} etkin cihaz' },
  'privacy.lockedByAge': 'Yaş politikası nedeniyle kilitli',
  'privacy.saved': 'Gizlilik ayarları kaydedildi',
  'privacy.profileDiscoverable': 'Profilim aramalarda bulunabilsin',
  'privacy.dmFromNonContacts': 'Kişilerim dışındakiler mesaj gönderebilsin',
  'privacy.lastSeen': 'Son görülme',
  'privacy.readReceipts': 'Okundu bilgisi',
  'privacy.phoneVisible': 'Telefon numaram görünsün',
  'privacy.audience.everyone': 'Herkes',
  'privacy.audience.contacts': 'Kişilerim',
  'privacy.audience.nobody': 'Hiç kimse',
  'common.save': 'Kaydet',
  'common.cancel': 'Vazgeç',
  'common.retry': 'Tekrar dene',
  'common.on': 'Açık',
  'common.off': 'Kapalı',
  'conn.offline': 'Çevrimdışı',
  'conn.connecting': 'Bağlanıyor…',
  'error.AUTH_INVALID_CREDENTIALS': 'E-posta/kullanıcı adı veya parola hatalı.',
  'error.AUTH_SESSION_EXPIRED': 'Oturumunun süresi doldu. Lütfen tekrar giriş yap.',
  'error.AUTH_REQUIRED': 'Devam etmek için giriş yapmalısın.',
  'error.AUTH_ORIGIN_REJECTED': 'İstek güvenlik kontrolünden geçmedi. Sayfayı yenileyip tekrar dene.',
  'error.AGE_BELOW_MINIMUM': 'Üzgünüz, bulunduğun ülkede bu yaşta DijitalApp hesabı açılamıyor.',
  'error.EMAIL_TAKEN': 'Bu e-posta adresiyle zaten bir hesap var.',
  'error.USERNAME_TAKEN': 'Bu kullanıcı adı kullanılamıyor.',
  'error.USERNAME_RESERVED': 'Bu kullanıcı adı ayrılmış, başka bir ad seç.',
  'error.VALIDATION_FAILED': 'Girdiğin bilgileri kontrol et.',
  'error.RATE_LIMITED': 'Çok fazla deneme yaptın. Biraz bekleyip tekrar dene.',
  'error.FORBIDDEN': 'Bu işlem için yetkin yok.',
  'error.NOT_FOUND': 'Aradığın şey bulunamadı.',
  'error.POLICY_LOCKED': 'Bu ayar yaşına uygun güvenlik politikası nedeniyle değiştirilemez.',
  'error.SPACE_VERIFICATION_REQUIRED': 'Bu alan türü kurum doğrulaması gerektirir.',
  'error.TERMS_NOT_ACCEPTED': 'Devam etmek için koşulları kabul etmelisin.',
  'error.ENTITLEMENT_LIMIT': 'Planındaki sınıra ulaştın.',
  'error.EMAIL_TOKEN_INVALID': 'Bu bağlantı geçersiz, kullanılmış ya da süresi dolmuş. Yeni bir bağlantı iste.',
  'error.PASSKEY_FAILED': 'Passkey doğrulanamadı. Tekrar dene.',
  'error.EMAIL_NOT_VERIFIED': 'Bu işlem için önce e-posta adresini doğrula.',
  'error.MESSAGING_NOT_ALLOWED': 'Bu kişiye şu an mesaj gönderemezsin.',
  'error.MESSAGE_TOO_LARGE': 'Mesaj çok uzun.',
  'error.AUTH_TICKET_INVALID': 'Canlı bağlantı kurulamadı. Tekrar deneniyor.',
  'error.PROTOCOL_INVALID_FRAME': 'Sunucuyla iletişimde bir sorun oldu.',
  'error.REGISTRATION_CLOSED': 'Yeni kayıtlar şu an kapalı.',
  'error.INVITE_INVALID': 'Davet kodu geçersiz, kullanılmış ya da süresi dolmuş.',
  'error.ADMIN_PASSKEY_REQUIRED': 'Yönetici işlemleri için son 12 saat içinde passkey ile giriş yapmış olmalısın.',
  'error.MESSAGE_EDIT_EXPIRED': 'Bu mesaj için düzenleme veya silme süresi doldu.',
  'error.ATTACHMENT_REJECTED': 'Bu dosya türü desteklenmiyor ya da dosya bozuk.',
  'error.STORAGE_QUOTA_EXCEEDED': 'Depolama alanın doldu. Eski dosyaları silerek yer açabilirsin.',
  'push.photo': '📷 Fotoğraf',
  'push.voice': '🎤 Sesli mesaj',
  'push.file': '📎 Dosya',
  'push.video': '🎬 Video',
  'error.PIN_LIMIT': 'En fazla 3 mesaj sabitlenebilir. Önce birinin sabitlemesini kaldır.',
  'chat.reply': 'Yanıtla',
  'chat.replyingTo': '{name} kişisine yanıt',
  'chat.originalMessage': 'Önceki bir mesaj',
  'chat.forward': 'İlet',
  'chat.forwarded': 'İletildi',
  'chat.forwardTitle': 'Mesajı ilet',
  'chat.forwardHint': 'En fazla 5 sohbet seçebilirsin.',
  'chat.forwardSent': 'İletildi.',
  'chat.forwardPartial': '{count} sohbete iletilemedi.',
  'chat.pin': 'Sabitle',
  'chat.unpin': 'Sabitlemeyi kaldır',
  'chat.pinned': 'Sabitlenmiş mesaj',
  'chat.react': 'Tepki ver',
  'chat.reactionsBy': '{emoji}: {names}',
  'chat.attachmentLabel': 'Ek',
  'error.AI_UNAVAILABLE': 'Yazım asistanı şu an kullanılamıyor.',
  'error.AI_CONSENT_REQUIRED': 'Yazım asistanını kullanmak için önce onay vermelisin.',
  'error.AI_QUOTA_EXCEEDED': 'Bugünkü yazım asistanı hakkın doldu. Yarın yeniden kullanabilirsin.',
  'error.AI_REFUSED': 'Yazım asistanı bu metni düzenlemedi.',
  'tpl.title': 'Şablonlar',
  'tpl.open': 'Şablon ekle',
  'tpl.search': 'Şablonlarda ara',
  'tpl.empty': 'Şablon bulunamadı.',
  'tpl.mine': 'Benim',
  'tpl.category.general': 'Genel',
  'tpl.category.education': 'Eğitim',
  'tpl.category.work': 'İş',
  'tpl.category.social': 'Sosyal',
  'tpl.saveDraft': 'Taslağı şablon olarak kaydet',
  'tpl.namePrompt': 'Şablon adı',
  'tpl.delete': 'Sil',
  'tpl.hint': 'Köşeli parantezli yerleri ([tarih] gibi) göndermeden önce doldur.',
  'ai.open': 'Yazım asistanı',
  'ai.title': 'Yazım asistanı',
  'ai.action.fix': 'Yazımı düzelt',
  'ai.action.shorten': 'Kısalt',
  'ai.action.formal': 'Resmi yap',
  'ai.action.friendly': 'Samimi yap',
  'ai.action.translate_en': 'İngilizceye çevir',
  'ai.action.translate_tr': 'Türkçeye çevir',
  'ai.consentTitle': 'Yazım asistanı hakkında',
  'ai.consentBody': 'Asistanı kullandığında, yalnız o an yazdığın taslak metin yapay zekâ sağlayıcısına ({provider}) gönderilir; sohbet geçmişin ve karşı tarafın mesajları gönderilmez. E-posta, telefon, IBAN, TC kimlik ve kart numaraları göndermeden önce gizlenir ve sonuçta geri konur. DijitalApp metni saklamaz; yalnız kaç kez kullandığını sayar. Sağlayıcının veri kullanımı kendi ticari koşullarına tabidir. Önerileri sen onaylamadan hiçbir şey gönderilmez. Onayını Yapay Zekâ sayfasından istediğin zaman geri çekebilirsin.',
  'ai.consentAccept': 'Anladım, kullanmak istiyorum',
  'ai.consentWithdraw': 'Onayı geri çek',
  'ai.e2eeWarning': 'Bu sohbet uçtan uca şifreli. Asistanı kullanırsan bu taslak şifrelemenin dışına çıkıp sağlayıcıya gönderilir.',
  'ai.suggestion': 'Öneri',
  'ai.use': 'Taslağa uygula',
  'ai.redacted': '{count} kişisel bilgi sağlayıcıdan gizlendi.',
  'ai.missing': 'Gizlenen {count} bilgi öneride yer almıyor; metni kontrol et.',
  'ai.remaining': 'Bugün kalan: {count}',
  'ai.working': 'Hazırlanıyor…',
  'ai.notForAccount': 'Yazım asistanı 18 yaş altı hesaplarda kullanılamaz.',
  'ai.unavailable': 'Yazım asistanı bu sunucuda henüz etkin değil.',
  'ai.pageIntro': 'Yazım asistanı mesaj taslaklarını düzeltir, kısaltır, tonunu değiştirir veya çevirir. Yalnız sen istediğinde ve yalnız taslağın gönderilir.',
  'ai.consentGiven': 'Onay verildi.',
  'ai.noConsent': 'Henüz onay vermedin.',
  'call.voice': 'Sesli ara',
  'call.video': 'Görüntülü ara',
  'call.incomingVoice': '{name} sesli arıyor…',
  'call.incomingVideo': '{name} görüntülü arıyor…',
  'call.calling': '{name} aranıyor…',
  'call.connecting': 'Bağlanıyor…',
  'call.accept': 'Cevapla',
  'call.acceptAudio': 'Sesli cevapla',
  'call.decline': 'Reddet',
  'call.hangup': 'Kapat',
  'call.mute': 'Sesi kapat',
  'call.unmute': 'Sesi aç',
  'call.cameraOff': 'Kamerayı kapat',
  'call.cameraOn': 'Kamerayı aç',
  'call.ended.hangup': 'Arama sona erdi.',
  'call.ended.rejected': 'Arama reddedildi.',
  'call.ended.missed': 'Cevap verilmedi.',
  'call.ended.busy': 'Kişi şu an başka bir aramada.',
  'call.ended.cancelled': 'Arama iptal edildi.',
  'call.ended.failed': 'Bağlantı kurulamadı.',
  'call.ended.disconnected': 'Bağlantı koptu.',
  'call.ended.answered_elsewhere': 'Başka bir cihazında cevaplandı.',
  'call.permissionDenied': 'Mikrofon/kamera izni verilmedi. Tarayıcı ayarlarından izin verebilirsin.',
  'call.encryptedNote': 'Şifreli bağlantı (DTLS-SRTP). Medya sunucu üzerinden aktarılır; karşı taraf IP adresini görmez.',
  'call.history': 'Aramalar',
  'call.noHistory': 'Henüz arama yok.',
  'call.incoming': 'Gelen',
  'call.outgoing': 'Giden',
  'call.missedLabel': 'Cevapsız',
  'call.duration': '{minutes} dk {seconds} sn',
  'call.unsupported': 'Bu tarayıcı aramaları desteklemiyor.',
  'push.call': '📞 Gelen arama',
  'call.ended.permission': 'Mikrofon/kamera izni verilmedi.',
  'call.ended.unsupported': 'Bu tarayıcı aramaları desteklemiyor.',
  'call.ended.not_allowed': 'Bu kişiyi arayamazsın (engel veya mesaj ayarları).',
  'push.videoCall': '🎥 Gelen görüntülü arama',
  'error.E2EE_IDENTITY_CHANGED': 'Doğruladığın biri şifreleme kimliğini değiştirdi. Göndermeden önce onu yeniden doğrula veya değişikliği kabul et (sohbet başlığındaki uyarı).',
  'e2ee.fileFailed': '🔒 Dosya bu cihazda açılamadı (anahtar yok ya da dosya değiştirilmiş).',
  'e2ee.unverifiedSender': 'Gönderen cihaz doğrulanamadı (yedekten geri yüklendi).',
  'e2ee.trust.verified': 'Doğrulandı',
  'e2ee.trust.unverified': 'Doğrulanmadı',
  'e2ee.trust.changed': 'Kimlik değişti',
  'e2ee.verifyTitle': '{name} kişisini doğrula',
  'e2ee.verifyIntro': 'Doğrulama, mesajlarının gerçekten {name} kişisinin cihazlarına gittiğinden emin olmanı sağlar. Yüz yüze veya bir görüntülü aramada yapın.',
  'e2ee.verifyEmoji': 'Emoji ile doğrula',
  'e2ee.verifyEmojiHint': 'İkinizin de DijitalApp açık olmalı. Karşı taraf isteği kabul edince iki ekranda emojiler görünür.',
  'e2ee.safetyCode': 'Güvenlik kodu ile doğrula',
  'e2ee.theirCode': '{name} kişisinin kodu',
  'e2ee.yourCode': 'Senin kodun',
  'e2ee.codeHint': 'Karşı taraf, kendi Ayarlar → Uçtan uca şifreleme ekranındaki "Senin kodun" ile buradaki "{name} kişisinin kodu"nu karşılaştırsın. Tamamen aynıysa doğrula.',
  'e2ee.codesMatch': 'Kodlar eşleşiyor, doğrula',
  'e2ee.noIdentity': 'Bu kişi henüz şifrelemeyi kurmamış.',
  'e2ee.requestIncoming': '{name} seninle doğrulama yapmak istiyor.',
  'e2ee.requestIncomingSelf': 'Diğer cihazın bu cihazla doğrulama yapmak istiyor.',
  'e2ee.accept': 'Kabul et',
  'e2ee.decline': 'Reddet',
  'e2ee.waitingAccept': 'Karşı tarafın isteği kabul etmesi bekleniyor…',
  'e2ee.emojiHint': 'İki ekranda da aynı emojiler aynı sırayla görünüyor mu?',
  'e2ee.match': 'Evet, eşleşiyor',
  'e2ee.noMatch': 'Hayır, eşleşmiyor',
  'e2ee.waitingOther': 'Karşı tarafın onayı bekleniyor…',
  'e2ee.done': 'Doğrulama tamamlandı ✓',
  'e2ee.cancelled': 'Doğrulama iptal edildi.',
  'e2ee.changedTitle': '{name} güvenlik kimliğini değiştirdi',
  'e2ee.changedBody': 'Yeni bir cihaz kurmuş ya da şifreleme kimliğini sıfırlamış olabilir; bu durumda mesajlar başka birine gidebilir. Emin olmak için yeniden doğrula. Doğrulamadan kabul edersen mesajlar yeni kimliğe gider.',
  'e2ee.acceptChange': 'Doğrulamadan kabul et',
  'e2ee.reverify': 'Yeniden doğrula',
  'e2ee.deviceUnverifiedTitle': 'Bu cihaz henüz doğrulanmadı',
  'e2ee.deviceUnverifiedBody': 'Şifreli sohbetleri bu cihazda okuyup yazabilmek için cihazı diğer cihazınla (emoji) doğrula. Geçmiş mesajlar için kurtarma anahtarını da girebilirsin.',
  'e2ee.verifyThisDevice': 'Diğer cihazımla doğrula',
  'e2ee.enterRecovery': 'Kurtarma anahtarı',
  'e2ee.restore': 'Geçmişi geri yükle',
  'e2ee.restored': '{count} sohbet anahtarı geri yüklendi.',
  'e2ee.wrongRecovery': 'Kurtarma anahtarı bu yedekle eşleşmiyor.',
  'e2ee.resetTitle': 'Şifreleme kimliğini sıfırla',
  'e2ee.resetBody': 'Yalnız tüm cihazlarını kaybettiysen kullan. Yeni bir şifreleme kimliği ve yeni bir kurtarma anahtarı oluşturulur; kişilerin "kimlik değişti" uyarısı görür ve seni yeniden doğrulaması gerekir. Eski mesajlar ancak eski kurtarma anahtarıyla okunabilir.',
  'e2ee.reset': 'Kimliği sıfırla',
  'e2ee.recoveryTitle': 'Kurtarma anahtarın',
  'e2ee.recoveryBody': 'Tüm cihazlarını kaybedersen şifreli mesaj geçmişini geri getirmenin tek yolu bu anahtar. Parola yöneticisine veya kâğıda kaydet ve kimseyle paylaşma. DijitalApp bu anahtarı göremez ve kaybedersen kurtaramaz.',
  'e2ee.saved': 'Kaydettim',
  'e2ee.settingsTitle': 'Uçtan uca şifreleme',
  'e2ee.thisDevice': 'Bu cihaz',
  'e2ee.showRecovery': 'Kurtarma anahtarını göster',
  'e2ee.notOnThisDevice': 'Bu cihazda yok; diğer cihazınla doğrulayınca gelir.',
  'e2ee.loading': 'Şifreleme hazırlanıyor…',
  'error.E2EE_REQUIRED': 'Bu sohbet uçtan uca şifreli; mesaj şifrelenmeden gönderilemez.',
  'error.E2EE_UNAVAILABLE': 'Uçtan uca şifreleme için sohbetteki herkesin en az bir cihazında şifrelemenin kurulmuş olması gerekir (DijitalApp bir kez açılınca kurulur).',
  'error.E2EE_UNSUPPORTED': 'Bu özellik uçtan uca şifreli sohbetlerde henüz kullanılamıyor.',
  'push.encrypted': '🔒 Şifreli mesaj',
  'e2ee.label': 'Uçtan uca şifreli (deneysel)',
  'e2ee.enable': 'Uçtan uca şifrelemeyi aç',
  'e2ee.enableConfirm': 'Bu sohbette uçtan uca şifreleme açılacak. Bu işlem geri alınamaz. Şifreli sohbetlerde şimdilik ek dosya, bağlantı önizlemesi, düzenleme, tepki ve iletme kullanılamaz; yeni bir cihaz eski şifreli mesajları göremez. Devam edilsin mi?',
  'e2ee.notice': 'Bu sohbetteki yeni mesajlar uçtan uca şifreli: içeriği DijitalApp sunucusu dahil kimse göremez. Deneysel: cihaz doğrulaması henüz yok.',
  'e2ee.cannotDecrypt': '🔒 Bu mesaj bu cihazda çözülemiyor (cihaz mesajdan sonra eklenmiş olabilir).',
  'e2ee.decrypting': '🔒 Çözülüyor…',
  'e2ee.encryptedBadge': 'Şifreli',
  'e2ee.notReady': 'Şifreleme bu cihazda hazırlanıyor; birkaç saniye sonra yeniden dene.',
  'e2ee.unsupportedBrowser': 'Bu tarayıcı uçtan uca şifrelemeyi desteklemiyor.',
  'chat.star': 'Yıldızla',
  'chat.unstar': 'Yıldızı kaldır',
  'chat.starred': 'Yıldızlı mesajlar',
  'chat.noStarred': 'Henüz yıldızlı mesaj yok. Bir mesajı yıldızlamak için mesaj seçeneklerinden "Yıldızla"yı seç.',
  'chat.openInChat': 'Sohbette göster',
  'chat.info': 'Bilgi',
  'chat.infoTitle': 'Mesaj bilgisi',
  'chat.readBy': 'Okudu',
  'chat.deliveredTo': 'İletildi',
  'chat.pendingTo': 'Henüz iletilmedi',
  'chat.readsHidden': 'Okundu bilgisini kapattığın için kimin okuduğu gösterilmiyor.',
  'chat.previewLoading': 'Bağlantı önizlemesi hazırlanıyor…',
  'chat.removePreview': 'Önizlemeyi kaldır',
  'error.ATTACHMENT_MALWARE': 'Bu dosyada zararlı yazılım bulundu; gönderilmedi.',
  'error.ATTACHMENT_SCAN_UNAVAILABLE': 'Dosya güvenlik taraması şu an yapılamıyor. Biraz sonra yeniden dene.',
  'chat.attach': 'Dosya ekle',
  'chat.record': 'Sesli mesaj kaydet',
  'chat.stopRecording': 'Kaydı bitir ve gönder',
  'chat.cancelRecording': 'Kaydı iptal et',
  'chat.recording': 'Kaydediliyor… {seconds} sn',
  'chat.uploading': 'Yükleniyor…',
  'chat.download': 'İndir',
  'chat.micDenied': 'Mikrofon izni verilmedi. Tarayıcı ayarlarından izin verebilirsin.',
  'chat.voiceMessage': 'Sesli mesaj',
  'chat.tooLarge': 'Dosya çok büyük (en fazla {mb} MB).',
  'chat.searchMessages': 'Mesajlar',
  'group.new': 'Yeni grup',
  'group.title': 'Grup adı',
  'group.description': 'Açıklama',
  'group.pickMembers': 'Kişilerinden üye seç (sonra da ekleyebilirsin):',
  'group.addHint': 'Bir kişi ancak gizlilik ayarı izin veriyorsa eklenir (varsayılan: yalnız onu ekleyen kişileri).',
  'group.create': 'Grubu oluştur',
  'group.info': 'Grup bilgisi',
  'group.memberCount': { one: '{count} üye', other: '{count} üye' },
  'group.someoneTyping': 'Biri yazıyor…',
  'group.onlyAdmins': 'Yalnız yöneticiler mesaj gönderebilsin (duyuru modu)',
  'group.role.owner': 'Sahip',
  'group.role.admin': 'Yönetici',
  'group.makeAdmin': 'Yönetici yap',
  'group.makeMember': 'Yöneticilikten al',
  'group.remove': 'Çıkar',
  'group.addMembers': 'Üye ekle',
  'group.add': 'Ekle',
  'group.leave': 'Gruptan ayrıl',
  'group.leaveConfirm': 'Bu gruptan ayrılmak istiyor musun?',
  'group.skipped': 'Şu kişiler gizlilik ayarları nedeniyle eklenemedi: {names}',
  'error.SPACE_LINK_INVALID': 'Bu davet bağlantısı geçersiz ya da süresi dolmuş.',
  'error.GROUP_LINK_INVALID': 'Bu grup bağlantısı geçersiz, iptal edilmiş ya da süresi dolmuş.',
  'error.GROUP_FULL': 'Grup üye sınırına ulaştı.',
  'group.inviteLink': 'Davet bağlantısı',
  'group.linkHint': 'Bağlantıya sahip herkes gruba katılabilir veya katılma isteği gönderebilir. Yalnız güvendiğin kişilerle paylaş.',
  'group.noLink': 'Etkin bağlantı yok.',
  'group.createLink': 'Bağlantı oluştur',
  'group.resetLink': 'Yeni bağlantı oluştur (eskisi geçersiz olur)',
  'group.revokeLink': 'Bağlantıyı iptal et',
  'group.requireApproval': 'Katılmak için yönetici onayı gereksin',
  'group.linkExpiry': 'Geçerlilik',
  'group.expiry.never': 'İptal edilene kadar',
  'group.expiry.24': '1 gün',
  'group.expiry.168': '1 hafta',
  'group.expiry.720': '30 gün',
  'group.linkActive': 'Etkin bağlantı: {date} tarihinde oluşturuldu · {uses} kullanım',
  'group.linkExpires': 'Bitiş: {date}',
  'group.linkOnce': 'Bağlantı yalnız şimdi gösterilir; güvenlik için saklanmaz. Kaybedersen yenisini oluştur.',
  'group.copyLink': 'Kopyala',
  'group.linkCopied': 'Kopyalandı',
  'group.joinRequests': 'Katılma istekleri',
  'group.noRequests': 'Bekleyen istek yok.',
  'group.approve': 'Onayla',
  'group.reject': 'Reddet',
  'group.previouslyRemoved': 'daha önce çıkarıldı',
  'group.pendingBadge': '{count} istek',
  'join.title': 'Gruba katıl',
  'join.join': 'Katıl',
  'join.request': 'Katılma isteği gönder',
  'join.requested': 'İsteğin gönderildi. Bir yönetici onayladığında grup sohbetlerinde görünecek.',
  'join.approvalNote': 'Bu gruba katılmak için yönetici onayı gerekiyor.',
  'join.open': 'Sohbeti aç',
  'join.missingToken': 'Bağlantıda davet bilgisi yok.',
  'join.privacyNote': 'Katıldığında grup üyeleri adını ve kullanıcı adını görebilir.',
  'privacy.groupAdd': 'Beni gruplara kim ekleyebilir',
  'chat.online': 'çevrimiçi',
  'chat.lastSeen': 'son görülme: {date}',
  'chat.edit': 'Düzenle',
  'chat.edited': 'düzenlendi',
  'chat.editing': 'Mesajı düzenliyorsun',
  'chat.save': 'Kaydet',
  'chat.deleteForMe': 'Benden sil',
  'chat.deleteForEveryone': 'Herkesten sil',
  'chat.deleted': 'Bu mesaj silindi',
  'chat.messageActions': 'Mesaj seçenekleri',
  'auth.inviteCode': 'Davet kodu',
  'auth.inviteHint': 'DijitalApp şu an davetle açılan kapalı beta aşamasında.',
  'auth.registrationClosed': 'Yeni kayıtlar şu an kapalı. Hesabın varsa giriş yapabilirsin.',
  'error.NETWORK': 'Sunucuya ulaşılamıyor. Bağlantını kontrol et.',
  'error.UNKNOWN': 'Beklenmeyen bir sorun oluştu. Tekrar dene.',
  'channel.title': 'Kanallar',
  'channel.intro': 'Kanallar birden çoğa yayındır: yalnız yöneticiler yazar, aboneler okur ve birbirini göremez.',
  'channel.mine': 'Kanallarım',
  'channel.none': 'Henüz bir kanala abone değilsin.',
  'channel.directory': 'Herkese açık kanallar',
  'channel.search': 'Kanal ara',
  'channel.noResults': 'Kanal bulunamadı.',
  'channel.subscribe': 'Abone ol',
  'channel.subscribers': { one: '{count} abone', other: '{count} abone' },
  'channel.privacyNote': 'Abone olduğunda kanal yöneticileri seni abone listesinde görebilir; diğer aboneler göremez.',
  'channel.adultsOnly': 'Herkese açık kanal dizini yalnız yetişkin hesaplar için. Özel kanallara davet bağlantısıyla katılabilirsin.',
  'channel.create': 'Kanal oluştur',
  'channel.name': 'Kanal adı',
  'channel.public': 'Herkese açık (dizinde görünsün)',
  'channel.publicNote': 'Herkese açık kanallar dizinde listelenir; yetişkin hesaplar bulup abone olabilir.',
  'channel.privateNote': 'Özel kanala yalnız davet bağlantısıyla katılınır (kanal bilgisinden bağlantı oluştur).',
  'channel.subscriberNote': 'Bu bir kanal: yalnız yöneticiler mesaj gönderebilir.',
  'community.title': 'Topluluk',
  'community.manage': 'Topluluk yönetimi',
  'community.announcements': 'Duyurular',
  'community.announcementsAdmin': 'Tüm üyelere duyuru gönder',
  'community.announcementsMember': 'Yöneticilerin duyuruları',
  'community.groups': 'Gruplar',
  'community.noGroups': 'Henüz grup yok.',
  'community.closed': 'kapalı',
  'community.newGroup': 'Yeni grup adı',
  'community.openGroup': 'Açık grup (topluluk üyeleri kendileri katılabilir)',
  'community.invite': 'Davet bağlantısı',
  'community.inviteNote': 'Bağlantıya sahip yetişkinler topluluğa katılır ve duyurulara abone olur.',
  'community.inviteFamilyNote': 'Bağlantıyı yalnız aile üyelerinle paylaş: aile alanlarına reşit olmayanlar da katılabilir.',
  'community.createLink': 'Yeni bağlantı oluştur (eskisi geçersiz olur)',
  'community.leave': 'Topluluktan ayrıl',
  'community.leaveConfirm': 'Topluluktan ayrılırsan duyuru kanalından ve topluluk gruplarından da çıkarsın. Devam edilsin mi?',
  'community.joinTitle': 'Topluluğa katıl',
  'community.open': 'Topluluğu aç',
  'community.joinPrivacyNote': 'Katıldığında topluluk yöneticileri adını görebilir; grupların üyeleri sen katıldığında görür.',
  'nav.calendar': 'Takvim',
  'planner.title': 'Takvim ve görevler',
  'planner.calendar': 'Takvim',
  'planner.tasks': 'Görevler',
  'planner.personal': 'Kişisel',
  'planner.prevMonth': 'Önceki ay',
  'planner.nextMonth': 'Sonraki ay',
  'planner.today': 'Bugün',
  'planner.noEvents': 'Bu ay etkinlik yok.',
  'planner.allDay': 'Tüm gün',
  'planner.cancelled': 'İptal edildi',
  'planner.responseCounts': '{going} katılıyor · {maybe} belki · {declined} katılmıyor',
  'planner.yourResponse': 'Yanıtın',
  'planner.response.going': 'Katılıyorum',
  'planner.response.maybe': 'Belki',
  'planner.response.declined': 'Katılmıyorum',
  'planner.cancel': 'İptal et',
  'planner.delete': 'Sil',
  'planner.cancelConfirm': 'Etkinlik herkes için iptal edilsin mi?',
  'planner.deleteConfirm': 'Etkinlik silinsin mi?',
  'planner.newEvent': 'Yeni etkinlik',
  'planner.eventTitle': 'Etkinlik adı',
  'planner.where': 'Nerede görünsün',
  'planner.date': 'Tarih',
  'planner.start': 'Başlangıç',
  'planner.end': 'Bitiş',
  'planner.location': 'Yer',
  'planner.description': 'Açıklama',
  'planner.scopeNote': 'Kişisel öğeleri yalnız sen görürsün; alan ve grup öğelerini o alanın/grubun üyeleri görür. Uçtan uca şifreli gruplarda takvim kullanılamaz.',
  'planner.addEvent': 'Etkinlik ekle',
  'planner.myTasks': 'Bana ait görevler',
  'planner.show': 'Göster',
  'planner.showDone': 'Tamamlananları göster',
  'planner.noTasks': 'Görev yok.',
  'planner.assignedTo': 'Atanan: {name}',
  'planner.due': 'Son: {date}',
  'planner.deleteTaskConfirm': 'Görev silinsin mi?',
  'planner.newTask': 'Yeni görev',
  'planner.taskTitle': 'Görev',
  'planner.assignee': 'Atanan kişi',
  'planner.unassigned': 'Atanmamış',
  'planner.dueDate': 'Son tarih',
  'planner.addTask': 'Görev ekle',
  'nav.learn': 'Eğitim',
  'error.EDU_INVITE_INVALID': 'Bu okul daveti geçersiz, kullanılmış ya da süresi dolmuş.',
  'learn.title': 'Eğitim',
  'learn.classes': 'Sınıflarım',
  'learn.teachers': 'Öğretmen: {names}',
  'learn.studentCount': { one: '{count} öğrenci', other: '{count} öğrenci' },
  'learn.role.teacher': 'Öğretmen',
  'learn.role.student': 'Öğrenci',
  'learn.role.guardian': 'Veli',
  'learn.childTitle': '{name} — ödev durumu',
  'learn.noClasses': 'sınıf yok',
  'learn.noAssignments': 'Ödev yok.',
  'learn.feedbackLine': 'Öğretmen: {text}',
  'learn.late': 'Geç',
  'learn.status.not_submitted': 'Teslim edilmedi',
  'learn.status.missing': 'Eksik',
  'learn.status.submitted': 'Teslim edildi',
  'learn.status.returned': 'Değerlendirildi',
  'learn.guardianNote': 'Veli olarak ödev durumunu, notu ve öğretmen geri bildirimini görürsün; çocuğunun cevaplarını ve mesajlarını görmezsin.',
  'learn.myGuardians': 'Velilerim',
  'learn.myGuardiansNote': 'Bu kişiler okulun onayıyla velin olarak bağlandı ve ödev durumunu, notunu görebilir; cevaplarını ve mesajlarını göremez.',
  'learn.empty': 'Öğretmeninden sınıf bağlantısı iste ya da okul davetini aç.',
  'learn.request.title': 'Okulunu ekle',
  'learn.request.note': 'Okul alanlarını yalnız DijitalApp ekibi açar: başvurunu inceler ve kurum bilgisini doğrular. Onaydan sonra okul yöneticisi sen olursun.',
  'learn.request.schoolName': 'Okul adı',
  'learn.request.city': 'Şehir',
  'learn.request.message': 'Not (görevin, iletişim)',
  'learn.request.submit': 'Başvur',
  'learn.request.pending': 'İnceleniyor',
  'learn.request.approved': 'Onaylandı',
  'learn.request.rejected': 'Reddedildi',
  'learn.link': 'Davet bağlantısı',
  'learn.verified': 'Doğrulanmış okul',
  'learn.people': 'Okul kişileri',
  'learn.inviteTeacher': 'Öğretmen daveti oluştur',
  'learn.pickStudent': 'Öğrenci seç',
  'learn.inviteGuardian': 'Veli daveti oluştur',
  'learn.teacherLinkNote': 'Tek kullanımlık, 7 gün geçerli; yalnız yetişkin hesaplar kullanabilir. Öğretmene doğrudan ilet.',
  'learn.guardianLinkNote': 'Tek kullanımlık, 7 gün geçerli; yalnız seçtiğin öğrencinin velisine (yetişkin) doğrudan ilet.',
  'learn.className': 'Sınıf adı',
  'learn.subject': 'Ders',
  'learn.createClass': 'Sınıf oluştur',
  'learn.back': 'Geri',
  'learn.studentsTitle': { one: '{count} öğrenci', other: '{count} öğrenci' },
  'learn.noStudents': 'Henüz öğrenci yok.',
  'learn.classLink': 'Sınıf bağlantısı oluştur',
  'learn.classLinkNote': 'Bağlantıyı yalnız öğrencilerinle paylaş (1 hafta geçerli). Reşit olmayanlar yalnız veli onayı verilmiş hesapla katılabilir.',
  'learn.newAssignment': 'Yeni ödev',
  'learn.assignmentTitle': 'Başlık',
  'learn.instructions': 'Yönerge',
  'learn.assign': 'Ödev ver',
  'learn.assignments': 'Ödevler',
  'learn.leaveClass': 'Sınıftan ayrıl',
  'learn.leaveConfirm': 'Sınıftan ayrılmak istiyor musun?',
  'learn.yourAnswer': 'Cevabın',
  'learn.submitNote': 'Öğretmen değerlendirene kadar düzenleyebilirsin. Yalnız öğretmenin görür.',
  'learn.submit': 'Teslim et',
  'learn.resubmit': 'Güncelle',
  'learn.counts': '{submitted}/{students} teslim · {returned} değerlendirildi',
  'learn.submissions': 'Teslimler',
  'learn.deleteAssignmentConfirm': 'Ödev silinsin mi?',
  'learn.feedback': 'Geri bildirim',
  'learn.grade': 'Not',
  'learn.return': 'Değerlendir',
  'learn.updateReturn': 'Güncelle',
  'learn.join.title': 'Okul daveti',
  'learn.join.teacher': '{school} okuluna öğretmen olarak katılıyorsun.',
  'learn.join.guardian': '{school} okulunda {name} adlı öğrencinin velisi olarak bağlanıyorsun.',
  'learn.join.class': '{school} — {className} sınıfına öğrenci olarak katılıyorsun.',
  'learn.join.teacherNote': 'Öğretmenler sınıf açar, ödev verir ve öğrencilerinin teslimlerini görür.',
  'learn.join.guardianNote': 'Çocuğunun ödev durumunu, notunu ve öğretmen geri bildirimini görürsün; cevaplarını ve mesajlarını görmezsin. Çocuğun seni velisi olarak görür.',
  'learn.join.classNote': 'Öğretmenlerinin adını ve kendi teslimlerini görürsün; sınıf arkadaşların seni bir sınıf listesinde görmez.',
  'learn.join.accept': 'Kabul et',
  'admin.tab.schools': 'Okul başvuruları',
  'admin.schools.note': 'Onay, başvurana doğrulanmış bir okul alanı açar ve onu okul yöneticisi yapar. Kurumu bant dışında (resmî yazı, kurum e-postası, telefon) doğrulamadan onaylama.',
  'admin.schools.none': 'Bekleyen başvuru yok.',
  'admin.schools.reviewNote': 'İnceleme notu (başvurana gösterilir)',
  'admin.schools.approve': 'Onayla',
  'admin.schools.reject': 'Reddet',
  'admin.schools.approveConfirm': 'Kurum doğrulandı mı? Onay, doğrulanmış bir okul alanı oluşturur.',
  'quiz.title': 'Quizler',
  'quiz.new': 'Yeni quiz',
  'quiz.none': 'Henüz quiz yok.',
  'quiz.state.draft': 'Taslak',
  'quiz.state.published': 'Yayında',
  'quiz.state.closed': 'Kapandı',
  'quiz.meta': '{questions} soru · {points} puan',
  'quiz.minutes': { one: '{count} dk', other: '{count} dk' },
  'quiz.stats': '{submitted}/{students} tamamladı · ort. {average}',
  'quiz.edit': 'Düzenle',
  'quiz.publish': 'Yayınla',
  'quiz.publishConfirm': 'Yayınlanan quizin soruları ve cevap anahtarı artık değiştirilemez. Yayınlansın mı?',
  'quiz.results': 'Sonuçlar',
  'quiz.close': 'Kapat',
  'quiz.deleteConfirm': 'Quiz silinsin mi?',
  'quiz.byQuestion': 'Soru bazında',
  'quiz.correctRate': '%{rate} doğru',
  'quiz.cancel': 'Vazgeç',
  'quiz.timeLimit': 'Süre (dk)',
  'quiz.showAnswers': 'Doğru cevaplar',
  'quiz.policy.after_submit': 'Teslimden hemen sonra gösterilsin',
  'quiz.policy.after_close': 'Quiz kapanınca gösterilsin',
  'quiz.policy.never': 'Gösterilmesin (yalnız puan)',
  'quiz.question': 'Soru {n}',
  'quiz.prompt': 'Soru metni',
  'quiz.option': 'Seçenek {n}',
  'quiz.markCorrect': 'Seçenek {n} doğru cevap',
  'quiz.removeOption': 'Seçenek {n}i kaldır',
  'quiz.addOption': 'Seçenek ekle',
  'quiz.points': 'Puan',
  'quiz.removeQuestion': 'Soruyu kaldır',
  'quiz.correctHint': 'Her sorunun doğru cevabını soldaki düğmeyle işaretle. Cevap anahtarı sunucuda tutulur; öğrenciler seçtiğin zamana kadar göremez.',
  'quiz.addQuestion': 'Soru ekle',
  'quiz.saveDraft': 'Taslağı kaydet',
  'quiz.status.not_started': 'Başlanmadı',
  'quiz.status.in_progress': 'Devam ediyor',
  'quiz.status.submitted': 'Tamamlandı',
  'quiz.status.missing': 'Kaçırıldı',
  'quiz.start': 'Başla',
  'quiz.startConfirm': 'Süre başladığında durmaz: {count} dakikan olacak. Başlansın mı?',
  'quiz.resume': 'Devam et',
  'quiz.view': 'Sonucu gör',
  'quiz.score': 'Puan: {score}/{max}',
  'quiz.answersLater': 'Doğru cevaplar öğretmenin seçtiği zamanda gösterilecek.',
  'quiz.pointsShort': { one: '{count} puan', other: '{count} puan' },
  'quiz.submit': 'Teslim et',
  'quiz.blankConfirm': '{count} soru boş. Yine de teslim edilsin mi?',
  'quiz.oneAttempt': 'Tek hakkın var; teslimden sonra değiştiremezsin. Süre bitince cevapların otomatik teslim edilir.',
  'study.title': 'Çalışma planım',
  'study.prevWeek': 'Önceki hafta',
  'study.nextWeek': 'Sonraki hafta',
  'study.progress': '{done}/{planned} dk çalışıldı · {blocksDone}/{blocksTotal} blok',
  'study.weekProgress': 'Haftalık ilerleme',
  'study.due': 'Bu hafta yapılacaklar',
  'study.planned': 'Planlandı',
  'study.auto': 'Haftayı planla',
  'study.autoCreated': { one: '{count} blok eklendi.', other: '{count} blok eklendi.' },
  'study.autoNothing': 'Eklenecek yeni bir şey yok.',
  'study.autoNote': 'Ödev ve quizler için son tarihten bir gün önceye, hedeflerin için haftanın kalan günlerine çalışma blokları önerilir. Geçmiş günlere blok konmaz; tekrar basınca aynı şeyler eklenmez.',
  'study.goals': 'Hedeflerim',
  'study.goalLine': 'bu hafta {done}/{target} dk',
  'study.goalNoTarget': 'bu hafta {done} dk',
  'study.goalDone': 'Tamamlandı',
  'study.newGoal': 'Yeni hedef',
  'study.goalTitle': 'Hedef',
  'study.weeklyMinutes': 'Haftalık dk',
  'study.addGoal': 'Hedef ekle',
  'study.minutes': { one: '{count} dk', other: '{count} dk' },
  'study.kind.custom': 'Serbest',
  'study.kind.homework': 'Ödev',
  'study.kind.quiz': 'Quiz',
  'study.kind.goal': 'Hedef',
  'study.removeBlock': '{title} bloğunu kaldır',
  'study.day': 'Gün',
  'study.blockTitle': 'Ne çalışacaksın',
  'study.minutesLabel': 'Dk',
  'study.forGoal': 'Hedef',
  'study.addBlock': 'Ekle',
  'study.share': 'İlerlememi velilerimle paylaş',
  'study.privacy': 'Planın yalnız sana aittir; öğretmenler görmez. Paylaşırsan velilerin yalnız haftalık toplamları ve hedef yüzdelerini görür, blok başlıklarını görmez.',
  'study.notShared': 'Çalışma planı paylaşılmıyor (paylaşmak çocuğunun kararıdır).',
  'tutor.title': 'AI öğretmen',
  'tutor.intro': 'Konuyu anlaman için ipuçları verir, soru sorar, kavramı açıklar. Ödevini senin yerine yapmaz.',
  'tutor.consent.hints': 'Cevabı hazır vermez; ipucu ve sorularla seni yönlendirir. Yanılabilir; önemli konuları öğretmenine danış.',
  'tutor.consent.redaction': 'Yazdıkların bir yapay zekâ hizmetine gönderilir; telefon, e-posta, kimlik numarası gibi kişisel bilgiler gönderilmeden önce gizlenir.',
  'tutor.consent.retention': 'Konuşmaların 30 gün saklanır, sonra silinir; istediğin zaman kendin silebilirsin.',
  'tutor.consent.visibility': 'Konuşmalarını yalnız sen görürsün. Öğretmenin ve velin yalnız kaç mesaj yazıldığını görür.',
  'tutor.consent.guardian': '18 yaşından küçük olduğun için velinin de onay vermesi gerekir.',
  'tutor.consent.accept': 'Anladım, kullanmak istiyorum',
  'tutor.consent.withdraw': 'AI öğretmen iznimi geri al',
  'tutor.reason.account': 'Hesabın şu an AI öğretmeni kullanamıyor (e-posta doğrulaması veya veli onaylı kayıt gerekli).',
  'tutor.reason.guardian_approval_required': 'Velinin AI öğretmen için onay vermesi bekleniyor. Velin Eğitim sayfasından onaylayabilir.',
  'tutor.reason.quiz_in_progress': 'Bu sınıfta süren bir quizin var; quiz bitene kadar AI öğretmen kapalı.',
  'tutor.reason.quota': 'Bugünkü AI öğretmen hakkın doldu; yarın yeniden kullanabilirsin.',
  'tutor.newSession': 'Yeni konuşma başlat',
  'tutor.remaining': { one: 'Bugün {count} mesaj hakkın kaldı.', other: 'Bugün {count} mesaj hakkın kaldı.' },
  'tutor.safety': 'Önemli',
  'tutor.thinking': 'AI öğretmen düşünüyor…',
  'tutor.redacted': { one: '{count} kişisel bilgi gönderilmeden önce gizlendi.', other: '{count} kişisel bilgi gönderilmeden önce gizlendi.' },
  'tutor.ask': 'Neyi anlamadın? Ne denedin?',
  'tutor.turnsLeft': { one: 'Bu konuşmada {count} mesaj kaldı', other: 'Bu konuşmada {count} mesaj kaldı' },
  'tutor.send': 'Gönder',
  'tutor.teacher.enable': 'Bu sınıfta AI öğretmeni aç',
  'tutor.teacher.note': 'Öğrenciler ipucu ve açıklama alır, hazır cevap almaz; quiz sırasında kapalıdır. 18 yaşından küçükler için veli onayı da gerekir. Konuşmaları siz göremezsiniz, yalnız kullanım sayılarını görürsünüz.',
  'tutor.teacher.usage': 'Bu hafta {students} öğrenci, {messages} mesaj',
  'tutor.guardian.approve': 'Çocuğumun AI öğretmeni kullanmasına izin veriyorum',
  'tutor.guardian.note': 'Öğretmeni sınıfta açtıysa ve çocuğun da kabul ettiyse kullanılabilir. İpucu verir, ödevi yapmaz; kişisel bilgiler gizlenir; konuşmalar 30 gün sonra silinir. Konuşmaların içeriğini göremezsiniz, yalnız haftalık mesaj sayısını görürsünüz.',
  'tutor.guardian.usage': { one: 'Bu hafta {count} mesaj', other: 'Bu hafta {count} mesaj' },
  'admin.tab.system': 'Sistem sağlığı',
  'admin.tab.config': 'Ayarlar',
  'admin.tab.audit': 'Denetim kaydı',
  'admin.tab.security': 'Güvenlik olayları',
  'admin.tab.ai': 'AI kullanımı',
  'adminOps.reasonPrompt': 'Bu değişikliğin nedeni (denetim kaydına yazılır):',
  'adminOps.reasonShort': 'Lütfen en az 5 karakterlik bir neden yaz.',
  'adminOps.config.note': 'Değişiklikler hemen etkinleşir ve nedenleriyle birlikte denetim kaydına yazılır. Yalnız süper yöneticiler değiştirebilir.',
  'adminOps.settings': 'Genel ayarlar',
  'adminOps.registrationMode': 'Kayıt modu',
  'adminOps.registration.open': 'Açık (herkes kayıt olabilir)',
  'adminOps.registration.invite': 'Davetle (davet kodu gerekir)',
  'adminOps.registration.closed': 'Kapalı',
  'adminOps.source.console': 'panelden ayarlandı',
  'adminOps.source.env': 'sunucu varsayılanı (.env)',
  'adminOps.range': 'aralık {min}–{max} · varsayılan {def}',
  'adminOps.save': 'Kaydet',
  'adminOps.flags': 'Özellikler (feature flag)',
  'adminOps.flagsNote': 'Bir özelliği kapatmak onu herkes için kapatır. Çocuk güvenliği tabanı bayrak değildir; hiçbir bayrak onu gevşetemez.',
  'adminOps.overrides': { one: '{count} istisna', other: '{count} istisna' },
  'adminOps.plan': 'Plan hakları',
  'adminOps.secretsTitle': 'Gizli anahtarlar neden burada değil?',
  'adminOps.secretsNote': 'Veritabanı şifresi, e-posta (SMTP), Web Push özel anahtarı, TURN sırrı, AI API anahtarı ve yedekleme bilgileri yalnız sunucudaki, yalnız yöneticinin okuyabildiği /etc/dijitalapp/*.env dosyalarında durur. Panelden yönetilselerdi ele geçirilen tek bir admin oturumu bütün sırları sızdırabilir ya da yedekleri başka yere yönlendirebilirdi.',
  'adminOps.search': 'Ara',
  'adminOps.more': 'Daha eski kayıtlar',
  'adminOps.empty': 'Kayıt yok.',
  'adminOps.refresh': 'Yenile',
  'adminOps.mail.test': 'Test e-postası gönder',
  'adminOps.mail.accepted': '{relay} kabul etti → {to}. Gelen kutunu ve spam klasörünü kontrol et.',
  'adminOps.mail.localRelay': 'Bu sunucudaki yerel aktarıcı ({relay}) kabul etti; ama gerçekten teslim edildiği doğrulanamıyor (bu sunucudan giden posta portları kapalı). SMTP_URL bir dış sağlayıcıyı (ör. Resend) göstermeli.',
  'adminOps.mail.failed': 'Gönderilemedi ({error}). Sunucudaki SMTP ayarını kontrol et.',
  'adminOps.audit.action': 'İşlem (önek)',
  'adminOps.audit.actor': 'Kim (kullanıcı adı)',
  'adminOps.audit.resourceType': 'Kaynak türü',
  'adminOps.audit.before': 'Önce',
  'adminOps.audit.after': 'Sonra',
  'adminOps.security.summary': 'Son 7 gün',
  'adminOps.security.counts': '24 sa: {d1} · 7 gün: {d7}',
  'adminOps.ai.period': 'Dönem',
  'adminOps.ai.days': { one: '{count} gün', other: '{count} gün' },
  'adminOps.ai.provider': 'Sağlayıcı',
  'adminOps.ai.off': 'Kapalı (ANTHROPIC_API_KEY yok)',
  'adminOps.ai.safety': 'AI öğretmen güvenlik yanıtı: {count} (içerik saklanmaz)',
  'adminOps.ai.line': '{requests} istek · {ok} başarılı · {refused} reddedildi · {errors} hata · {users} kişi · {tokens} token · ort. {latency} ms',
  'adminOps.ai.daily': 'Günlük istek',
  'adminOps.ai.topUsers': 'En çok kullananlar',
  'adminOps.ai.privacy': 'Yalnız sayılar tutulur; hiçbir AI isteğinin metni saklanmaz.',
  'adminOps.state.ok': 'çalışıyor',
  'adminOps.state.degraded': 'kısıtlı',
  'adminOps.state.fail': 'hata',
  'adminOps.state.off': 'kapalı',
  'adminOps.system.release': 'Sürüm: {release} · Node {node}',
  'adminOps.system.process': 'Çalışma süresi: {uptime} dk · bellek {memory} MB',
  'adminOps.system.migrations': 'Veritabanı geçişleri: {count} · son: {latest}',
  'adminOps.system.outbox': 'Bekleyen olay: {pending} · en eskisi {oldest} sn',
  'adminOps.system.db': 'Veritabanı boyutu: {size} MB',
  'adminOps.system.counts': 'Kullanıcı: {users} · son 24 sa yeni: {newUsers} · mesaj: {messages} · bu sunucudaki canlı bağlantı: {sockets}',
  'adminOps.system.note': 'Yedekleme ve dış izleme sunucudaki zamanlayıcılarla çalışır; durumları bu sürümde panelde gösterilmiyor.',
  'settings.section.account': 'Hesap',
  'settings.section.account.desc': 'Profilin ve oturumun',
  'settings.section.appearance': 'Görünüm',
  'settings.section.appearance.desc': 'Tema ve dil',
  'settings.section.privacy': 'Gizlilik',
  'settings.section.privacy.desc': 'Seni kim görebilir, kim yazabilir',
  'settings.section.notifications': 'Bildirimler',
  'settings.section.notifications.desc': 'Anlık bildirimler ve önizleme',
  'settings.section.security': 'Güvenlik',
  'settings.section.security.desc': 'Passkey ve uçtan uca şifreleme',
  'settings.section.devices': 'Cihazlar',
  'settings.section.devices.desc': 'Oturum açık cihazların',
  'settings.theme': 'Tema',
  'settings.account.details': 'Hesap bilgileri',
  'settings.account.email': 'E-posta',
  'settings.account.verified': 'Doğrulandı',
  'settings.account.unverified': 'Doğrulanmadı',
  'settings.account.type': 'Hesap türü',
  'settings.account.adult': 'Yetişkin',
  'settings.account.minor': '18 yaş altı (korumalı)',
  'settings.account.since': 'Üyelik tarihi',
  'settings.account.session': 'Oturum',
  'settings.account.sessionHint': 'Bu cihazdan çıkış yapar. Diğer cihazlarını Cihazlar bölümünden yönetebilirsin.',
  'e2ee.deviceUnverifiedShort': 'şifreli sohbetler için gerekli',
  'e2ee.fix': 'Çöz',
  'e2ee.later': 'Daha sonra',
  'e2ee.openSecurity': 'Güvenlik ayarları',
  'e2ee.singleDeviceHint': 'Başka cihazın yoksa ve kurtarma anahtarını kaydetmediysen: Ayarlar → Güvenlik → "Şifreleme kimliğini sıfırla". Henüz şifreli sohbetin yoksa bir şey kaybetmezsin.',
  'chat.splashTitle': '{brand} Web',
  'chat.splashFoot': 'Bağlantın her zaman şifreli. Dilediğin sohbette uçtan uca şifrelemeyi açabilirsin.',
  'chat.newDesc': 'Bir kişiyi kullanıcı adıyla ekle ya da yeni bir grup kur.',
  'e2ee.fix.otherTitle': 'Diğer cihazından onayla',
  'e2ee.fix.otherBody': 'DijitalApp\'in açık olduğu diğer cihazında gelen isteği kabul et ve iki ekrandaki emojilerin aynı olduğunu onayla.',
  'e2ee.fix.waiting': 'Diğer cihazın onayı bekleniyor…',
  'e2ee.fix.resetTitle': 'Bu cihazda şifrelemeyi yeniden kur',
  'e2ee.fix.resetBody': 'Hesabında başka açık cihaz yok. Şifreni girmen yeterli: bu cihaz doğrulanır ve sana yeni bir kurtarma anahtarı verilir (bir yere kaydet). Eski şifreli mesajlar yalnız eski kurtarma anahtarıyla okunabilir.',
  'e2ee.fix.resetAction': 'Yeniden kur',
  'e2ee.fix.recoveryTitle': 'Kurtarma anahtarıyla doğrula',
  'e2ee.fix.haveRecovery': 'Kurtarma anahtarım var',
  'e2ee.fix.noAccess': 'Diğer cihazıma erişemiyorum',
  'e2ee.fix.resetBodyOther': 'Diğer cihazına ulaşamıyorsan şifreni girmen yeterli: bu cihaz doğrulanır ve sana yeni bir kurtarma anahtarı verilir (bir yere kaydet). Eski şifreli mesajlar yalnız eski kurtarma anahtarıyla okunabilir.',
  'adminOps.flag.messaging': 'Mesajlaşma',
  'adminOps.flag.messaging.desc': 'Birebir ve grup sohbetleri',
  'adminOps.flag.voice_messages': 'Sesli mesajlar',
  'adminOps.flag.voice_messages.desc': 'Sohbetlerde ses kaydı gönderme',
  'adminOps.flag.groups': 'Gruplar',
  'adminOps.flag.groups.desc': 'Grup sohbetleri ve davet bağlantıları',
  'adminOps.flag.communities': 'Topluluklar',
  'adminOps.flag.communities.desc': 'Topluluk ve aile alanları, duyuru kanalı',
  'adminOps.flag.channels': 'Kanallar',
  'adminOps.flag.channels.desc': 'Birden çoğa yayın ve kanal dizini',
  'adminOps.flag.stories': 'Hikâyeler',
  'adminOps.flag.stories.desc': 'Henüz hazır değil',
  'adminOps.flag.voice_calls': 'Sesli aramalar',
  'adminOps.flag.voice_calls.desc': 'Birebir sesli arama',
  'adminOps.flag.video_calls': 'Görüntülü aramalar',
  'adminOps.flag.video_calls.desc': 'Birebir görüntülü arama',
  'adminOps.flag.screen_share': 'Ekran paylaşımı',
  'adminOps.flag.screen_share.desc': 'Henüz hazır değil',
  'adminOps.flag.bots': 'Botlar',
  'adminOps.flag.bots.desc': 'Henüz hazır değil',
  'adminOps.flag.business': 'İşletme hesapları',
  'adminOps.flag.business.desc': 'Henüz hazır değil',
  'adminOps.flag.translation': 'Çeviri',
  'adminOps.flag.translation.desc': 'Henüz hazır değil',
  'adminOps.flag.ai': 'AI yazım asistanı',
  'adminOps.flag.ai.desc': 'Taslak düzeltme, kısaltma, çeviri',
  'adminOps.flag.payments': 'Ödemeler',
  'adminOps.flag.payments.desc': 'Henüz hazır değil',
  'adminOps.flag.location': 'Konum paylaşımı',
  'adminOps.flag.location.desc': 'Henüz hazır değil; çocuklar için her zaman kapalı',
  'adminOps.flag.public_discovery': 'Herkese açık keşif',
  'adminOps.flag.public_discovery.desc': 'Profillerin aramada bulunması; çocuklar için her zaman kapalı',
  'adminOps.flag.learning_hub': 'Eğitim',
  'adminOps.flag.learning_hub.desc': 'Okullar, sınıflar, ödev, quiz, çalışma planı',
  'adminOps.flag.events': 'Etkinlik alanları',
  'adminOps.flag.events.desc': 'Etkinlik türünde alan açabilme',
  'adminOps.flag.calendar': 'Takvim',
  'adminOps.flag.calendar.desc': 'Kişisel, alan ve grup etkinlikleri',
  'adminOps.flag.tasks': 'Görevler',
  'adminOps.flag.tasks.desc': 'Kişisel, alan ve grup görevleri',
  'adminOps.flag.ai_tutor': 'AI öğretmen',
  'adminOps.flag.ai_tutor.desc': 'Sınıflarda pedagojik AI yardımı',
  'adminOps.flag.passkey_login': 'Passkey ile giriş',
  'adminOps.flag.passkey_login.desc': 'Şifresiz, cihaz kilidiyle giriş',
  'adminOps.flag.push_notifications': 'Anlık bildirimler',
  'adminOps.flag.push_notifications.desc': 'Tarayıcı ve telefon bildirimleri',
  'adminOps.rc.maxMessageLength': 'En uzun mesaj',
  'adminOps.rc.maxMessageLength.unit': 'karakter',
  'adminOps.rc.maxUploadSizeMb': 'En büyük dosya',
  'adminOps.rc.maxUploadSizeMb.unit': 'MB',
  'adminOps.rc.typingTimeoutMs': '"Yazıyor…" süresi',
  'adminOps.rc.typingTimeoutMs.unit': 'milisaniye',
  'adminOps.rc.presenceTimeoutMs': 'Çevrimiçi sayılma süresi',
  'adminOps.rc.presenceTimeoutMs.unit': 'milisaniye',
  'adminOps.rc.storyDurationHours': 'Hikâye süresi',
  'adminOps.rc.storyDurationHours.unit': 'saat',
  'adminOps.ent.limit.ai_requests_daily': 'Günlük AI yazım asistanı hakkı',
  'adminOps.ent.limit.ai_requests_daily.unit': 'istek',
  'adminOps.ent.limit.ai_tutor_daily': 'Günlük AI öğretmen hakkı',
  'adminOps.ent.limit.ai_tutor_daily.unit': 'mesaj',
  'adminOps.ent.limit.channel_subscribers': 'Kanal başına abone',
  'adminOps.ent.limit.channel_subscribers.unit': 'kişi',
  'adminOps.ent.limit.community_groups': 'Topluluk başına grup',
  'adminOps.ent.limit.community_groups.unit': 'grup',
  'adminOps.ent.limit.devices': 'Cihaz sayısı',
  'adminOps.ent.limit.devices.unit': 'cihaz',
  'adminOps.ent.limit.group_members': 'Grup başına üye',
  'adminOps.ent.limit.group_members.unit': 'kişi',
  'adminOps.ent.limit.open_tasks_per_scope': 'Açık görev (alan/grup başına)',
  'adminOps.ent.limit.open_tasks_per_scope.unit': 'görev',
  'adminOps.ent.limit.spaces_owned': 'Sahip olunabilecek alan',
  'adminOps.ent.limit.spaces_owned.unit': 'alan',
  'adminOps.ent.limit.storage_mb': 'Depolama alanı',
  'adminOps.ent.limit.storage_mb.unit': 'MB',
  'adminOps.check.postgres': 'Veritabanı',
  'adminOps.check.redis': 'Önbellek (Redis)',
  'adminOps.check.clamav': 'Virüs taraması',
  'adminOps.check.ai': 'AI sağlayıcısı',
  'adminOps.check.push': 'Anlık bildirim',
  'adminOps.check.turn': 'Arama sunucusu (TURN)',
  'adminOps.check.mail': 'E-posta gönderimi',
  'adminOps.check.outbox': 'Olay kuyruğu',
  'adminOps.aiAction.fix': 'Yazım düzeltme',
  'adminOps.aiAction.shorten': 'Kısaltma',
  'adminOps.aiAction.formal': 'Resmîleştirme',
  'adminOps.aiAction.friendly': 'Samimileştirme',
  'adminOps.aiAction.translate_en': 'İngilizceye çeviri',
  'adminOps.aiAction.translate_tr': 'Türkçeye çeviri',
  'adminOps.aiAction.tutor': 'AI öğretmen',
  'adminOps.secKind.login.failed': 'Başarısız giriş',
  'adminOps.secKind.login.rate_limited': 'Çok fazla giriş denemesi',
  'adminOps.secKind.passkey.login_failed': 'Başarısız passkey girişi',
  'adminOps.secKind.password.reset_requested': 'Şifre sıfırlama istendi',
  'adminOps.secKind.password.reset_completed': 'Şifre sıfırlandı',
  'adminOps.secKind.privacy.floor_violation': 'Çocuk koruma kuralı denemesi',
  'adminOps.secKind.tutor.safety_reply': 'AI öğretmen güvenlik yanıtı',
  'adminOps.secKind.username.changed': 'Kullanıcı adı değişti',
  'role.platform.super_admin': 'Süper yönetici',
  'role.platform.admin': 'Yönetici',
  'role.platform.moderator': 'Moderatör',
  'role.platform.support': 'Destek',
  'spaces.role.owner': 'Sahip',
  'spaces.role.admin': 'Yönetici',
  'spaces.role.member': 'Üye',
  'spaces.role.guest': 'Misafir',
  'adminOps.registrationModeHint': 'Yeni kullanıcıların nasıl kayıt olabileceği',
  'adminOps.remoteTitle': 'Uygulama sınırları',
  'error.USERNAME_CHANGE_TOO_SOON': 'Kullanıcı adını 30 günde bir değiştirebilirsin.',
  'settings.account.username': 'Kullanıcı adı',
  'settings.account.changeUsername': 'Kullanıcı adını değiştir',
  'settings.account.newUsername': 'Yeni kullanıcı adı',
  'settings.account.usernameRules': '3–30 karakter; küçük harf, rakam, "_" ve "." kullanılabilir. Ayda bir kez (30 günde bir) değiştirebilirsin; eski adın 30 gün boyunca başkasına verilmez.',
  'settings.account.passwordToConfirm': 'Onaylamak için şifren',
  'settings.account.usernameSaved': 'Kullanıcı adın güncellendi.',
  'settings.account.usernameNextChange': 'Bir sonraki değişiklik: {date}',
  'planner.calendarDesc': 'Kişisel, alan ve grup etkinliklerin',
  'planner.tasksDesc': 'Sana ait ve atanan görevler',
  'learn.nav.home': 'Genel bakış',
  'learn.nav.homeDesc': 'Sınıfların, okulların ve çocukların',
  'learn.nav.planDesc': 'Hedefler ve haftalık çalışma planı',
  'learn.nav.schoolDesc': 'Okulunu doğrulanmış olarak ekle',
  'learn.emptyTitle': 'Henüz bir sınıfın yok',
  'spaces.createDesc': 'Ailen ya da topluluğun için ortak bir alan kur.',
  'spaces.cannotCreate': 'Bu hesap yeni alan oluşturamaz.',
  'spaces.typeDesc.personal': 'Yalnız sana ait',
  'spaces.typeDesc.family': 'Ailen için: çocuklar da katılabilir',
  'spaces.typeDesc.community': 'Mahalle, dernek, kulüp: duyurular ve gruplar',
  'spaces.typeDesc.school': 'Okullar personel onayıyla açılır',
  'spaces.typeDesc.business': 'Kurum doğrulaması gerekir',
  'spaces.typeDesc.event': 'Bir etkinlik için geçici alan',
  'call.historyDesc': 'Gelen, giden ve cevapsız aramaların',
  'call.howTo': 'Bir sohbeti açıp üstteki telefon ya da kamera düğmesiyle arama başlatabilirsin.',
  'auth.hero.title': 'Aileniz, okulunuz ve topluluğunuz için güvenli mesajlaşma',
  'auth.hero.p1': 'Sohbetler, gruplar ve sesli/görüntülü aramalar',
  'auth.hero.p2': 'Aile ve topluluk alanları, kanallar',
  'auth.hero.p3': 'Okul, ödev, quiz ve çalışma planı',
  'auth.login.subtitle': 'Tekrar hoş geldin! Hesabına giriş yap.',
  'auth.register.subtitle': 'Birkaç adımda ücretsiz hesabını oluştur.',
  'date.placeholder': 'gg.aa.yyyy',
  'date.open': 'Takvimi aç',
  'date.tomorrow': 'Yarın',
  'date.nextWeek': 'Gelecek hafta',
  'date.prevMonth': 'Önceki ay',
  'date.nextMonth': 'Sonraki ay',
  'date.clear': 'Tarihi temizle',
  'time.placeholder': 'ss:dd',
  'admin.tab.usernames': 'Kullanıcı adları',
  'error.USERNAME_NOT_ALLOWED': 'Bu kullanıcı adı uygunsuz ifadeler içerdiği için kullanılamaz.',
  'settings.account.usernameRulesStaff': '3–30 karakter; küçük harf, rakam, "_" ve "." kullanılabilir. Yönetici olarak istediğin kadar değiştirebilir, ayrılmış adları (ör. destek, resmi) kullanabilirsin.',
  'settings.account.usernameAvailable': '@{name} kullanılabilir',
  'settings.account.usernameReason.invalid': '3–30 karakter; yalnız küçük harf, rakam, "_" ve "."',
  'settings.account.usernameReason.same': 'Bu zaten senin kullanıcı adın.',
  'settings.account.usernameReason.taken': 'Bu kullanıcı adı alınmış.',
  'settings.account.usernameReason.reserved': 'Bu ad platform veya resmi kurumlar için ayrılmış.',
  'settings.account.usernameReason.blocked': 'Bu ad uygunsuz ifadeler içerdiği için kullanılamaz.',
  'adminOps.uname.intro': 'Kayıt olurken ve kullanıcı adı değiştirirken uygulanır. "Ayrılmış" adları yalnız yöneticiler alabilir; "Yasaklı" adları kimse alamaz. Benzer yazımlar da yakalanır (a.d.m.i.n, 4ll4h, s1kt1r).',
  'adminOps.uname.testTitle': 'Bir adı dene',
  'adminOps.uname.testPlaceholder': 'ör. destek_ekibi',
  'adminOps.uname.test': 'Dene',
  'adminOps.uname.invalid': 'Biçim geçersiz: 3–30 karakter; küçük harf, rakam, "_" ve "."',
  'adminOps.uname.allowed': '@{name} normal kullanıcılar için uygun.',
  'adminOps.uname.refused.reserved': 'Ayrılmış: "{term}" kuralına takılıyor ({source}). Yalnız yöneticiler alabilir.',
  'adminOps.uname.refused.blocked': 'Yasaklı: "{term}" kuralına takılıyor ({source}). Kimse alamaz.',
  'adminOps.uname.sourceBuiltin': 'yerleşik liste',
  'adminOps.uname.sourceCustom': 'senin listen',
  'adminOps.uname.addTitle': 'Kural ekle',
  'adminOps.uname.term': 'İfade',
  'adminOps.uname.match': 'Eşleşme',
  'adminOps.uname.kind': 'Tür',
  'adminOps.uname.note': 'Not (isteğe bağlı)',
  'adminOps.uname.add': 'Ekle',
  'adminOps.uname.match.whole': 'Adın tamamı',
  'adminOps.uname.match.word': 'Kelime olarak',
  'adminOps.uname.match.contains': 'İçinde geçerse',
  'adminOps.uname.matchHint.whole': 'Yalnız adın kendisi bu ifade ise: "iletisim" engellenir, "iletisim_ali" serbest.',
  'adminOps.uname.matchHint.word': 'Ad bu ifade ise ya da "_" "." ile ayrılmış bir parçası bu ise: "admin_ali" engellenir, "badminton" serbest.',
  'adminOps.uname.matchHint.contains': 'İfade adın herhangi bir yerinde geçerse. Yalnız uzun, başka anlamı olmayan ifadeler için kullan; kısa ifadeler gerçek isimleri de engelleyebilir.',
  'adminOps.uname.kind.reserved': 'Ayrılmış (yalnız yöneticiler)',
  'adminOps.uname.kind.blocked': 'Yasaklı (kimse alamaz)',
  'adminOps.uname.customTitle': 'Senin eklediklerin ({count})',
  'adminOps.uname.none': 'Henüz kural eklemedin.',
  'adminOps.uname.remove': 'Kaldır',
  'adminOps.uname.builtinTitle': 'Yerleşik listeler',
  'adminOps.uname.builtinHint': 'Uygulamayla birlikte gelir ve her zaman uygulanır; buradan kaldırılamaz. Eksik gördüğün ifadeleri yukarıdan ekleyebilirsin.',
  'install.button': 'Uygulamayı yükle',
  'settings.themeToggle': 'Açık / koyu tema',
  'install.addToHome': 'Ana ekrana ekle',
  'install.title': 'DijitalApp uygulaması',
  'install.why': 'Ana ekranından tek dokunuşla aç, kendi penceresinde çalışsın ve bildirimleri alsın. Mağaza gerekmez, yer kaplamaz.',
  'install.installed': 'DijitalApp bu cihazda uygulama olarak yüklü.',
  'install.ios1': 'Safari’de alttaki Paylaş simgesine (kare ve yukarı ok) dokun.',
  'install.ios2': '“Ana Ekrana Ekle”yi seç.',
  'install.ios3': 'Sağ üstteki “Ekle”ye dokun.',
  'install.other': 'Tarayıcının menüsünden “Uygulamayı yükle” ya da “Ana ekrana ekle” seçeneğini kullanabilirsin.',
  'admin.tab.site': 'Web sitesi',
  'error.QR_LOGIN_EXPIRED': 'Bu QR kodunun süresi dolmuş ya da kullanılmış.',
  'error.SITE_CHANGED': 'Bu içerik siz düzenlerken başka biri tarafından kaydedildi. Sayfayı yenileyip tekrar deneyin.',
  'adminOps.site.language': 'Dil',
  'adminOps.site.version': 'Sürüm {version} · {by} · {date}',
  'adminOps.site.defaults': 'Varsayılan içerik yayında (henüz düzenlenmedi)',
  'adminOps.site.open': 'Siteyi aç',
  'adminOps.site.undo': 'Değişiklikleri geri al',
  'adminOps.site.save': 'Kaydet ve yayınla',
  'adminOps.site.saved': 'Kaydedildi ve yayına alındı.',
  'adminOps.site.restored': 'Seçilen sürüm geri yüklendi ve yayına alındı.',
  'adminOps.site.discard': 'Kaydedilmemiş değişiklikler var. Yine de dil değiştirilsin mi?',
  'adminOps.site.sections': 'Bölümler',
  'adminOps.site.resetSection': 'Bu bölümü varsayılana döndür',
  'adminOps.site.history': 'Sürüm geçmişi',
  'adminOps.site.noHistory': 'Henüz kayıt yok.',
  'adminOps.site.restore': 'Bu sürüme dön',
  'adminOps.site.add': 'Ekle',
  'adminOps.site.remove': 'Kaldır',
  'adminOps.site.up': 'Yukarı taşı',
  'adminOps.site.down': 'Aşağı taşı',
  'adminOps.site.section.general': 'Genel',
  'adminOps.site.section.hero': 'Giriş',
  'adminOps.site.section.product': 'Ürün',
  'adminOps.site.section.security': 'Güvenlik',
  'adminOps.site.section.business': 'Business ve Asistan',
  'adminOps.site.section.plus': 'Plus',
  'adminOps.site.section.plans': 'Paketler',
  'adminOps.site.section.apps': 'Uygulamalar',
  'adminOps.site.section.faq': 'Sorular',
  'adminOps.site.section.final': 'Kapanış ve alt bilgi',
  'siteField.meta': 'Arama motoru bilgileri',
  'siteField.title': 'Başlık',
  'siteField.description': 'Açıklama',
  'siteField.labels': 'Etiketler',
  'siteField.comingSoon': 'Yakında etiketi',
  'siteField.available': 'Kullanılabilir etiketi',
  'siteField.signIn': 'Giriş düğmesi',
  'siteField.start': 'Kayıt düğmesi',
  'siteField.menu': 'Menü',
  'siteField.otherLanguage': 'Diğer dil bağlantısı',
  'siteField.skip': 'İçeriğe geç bağlantısı',
  'siteField.theme': 'Tema düğmesi',
  'siteField.toTop': 'Yukarı çık düğmesi',
  'siteField.home': 'Ana sayfa (mobil alt menü)',
  'siteField.nav': 'Üst menü',
  'siteField.product': 'Ürün',
  'siteField.security': 'Güvenlik',
  'siteField.business': 'Business',
  'siteField.plus': 'Plus',
  'siteField.apps': 'Uygulamalar',
  'siteField.faq': 'Sorular',
  'siteField.hero': 'Giriş bölümü',
  'siteField.eyebrow': 'Üst satır',
  'siteField.lead': 'Açıklama metni',
  'siteField.primary': 'Ana düğme',
  'siteField.secondary': 'İkinci düğme',
  'siteField.label': 'Yazı',
  'siteField.url': 'Bağlantı',
  'siteField.notes': 'Küçük notlar',
  'siteField.visible': 'Bu bölümü göster',
  'siteField.kicker': 'Üst başlık',
  'siteField.rows': 'Satırlar',
  'siteField.visual': 'Görsel',
  'siteField.visual.chat': 'Sohbet ekranı',
  'siteField.visual.spaces': 'Alan ekranı',
  'siteField.visual.learn': 'Eğitim ekranı',
  'siteField.visual.calendar': 'Takvim ekranı',
  'siteField.points': 'Maddeler',
  'siteField.body': 'Metin',
  'siteField.items': 'Öğeler',
  'siteField.assistant': 'DijitalApp Asistan',
  'siteField.demoQuestion': 'Örnek soru',
  'siteField.demoAnswer': 'Örnek yanıt',
  'siteField.demoSource': 'Örnek kaynak',
  'siteField.plans': 'Paketler',
  'siteField.name': 'Ad',
  'siteField.price': 'Fiyat',
  'siteField.note': 'Not',
  'siteField.status': 'Durum',
  'siteField.status.available': 'Kullanılabilir',
  'siteField.status.soon': 'Yakında',
  'siteField.features': 'Özellikler',
  'siteField.cta': 'Düğme',
  'siteField.kind': 'Tür',
  'siteField.kind.web': 'Web',
  'siteField.kind.pwa': 'Ana ekran uygulaması',
  'siteField.kind.ios': 'App Store',
  'siteField.kind.android': 'Google Play',
  'siteField.kind.huawei': 'AppGallery',
  'siteField.q': 'Soru',
  'siteField.a': 'Yanıt',
  'siteField.final': 'Kapanış',
  'siteField.footer': 'Alt bilgi',
  'siteField.tagline': 'Kısa tanım',
  'siteField.contactEmail': 'İletişim e-postası',
  'siteField.columns': 'Sütunlar',
  'siteField.links': 'Bağlantılar',
  'siteField.item': 'Madde',
  'qr.modes': 'Giriş yöntemi',
  'qr.withPassword': 'Şifreyle',
  'qr.withPhone': 'Telefonla (QR)',
  'qr.codeLabel': 'Giriş için QR kodu',
  'qr.step1': 'Telefonunda DijitalApp’i aç.',
  'qr.step2': 'Ayarlar → Cihazlar → “QR kodu okut”a dokun ya da telefon kamerasıyla bu kodu okut.',
  'qr.step3': 'Telefonda girişi onayla; bu bilgisayarda oturumun açılır.',
  'qr.desktopSafety': 'Kod iki dakika geçerlidir ve yalnız bir kez kullanılır. Ortak bir bilgisayardaysan işin bitince çıkış yap.',
  'qr.newCode': 'Yeni kod oluştur',
  'qr.declined': 'Giriş telefondan reddedildi.',
  'qr.paused': 'Kodun süresi doldu.',
  'qr.invalid': 'Bu bağlantı geçersiz.',
  'qr.expired': 'Bu kodun süresi dolmuş ya da kullanılmış. Bilgisayardaki yeni kodu okut.',
  'qr.askTitle': 'Bu bilgisayarda {brand}’e giriş yapılsın mı?',
  'qr.device': 'Cihaz',
  'qr.address': 'IP adresi',
  'qr.when': 'İstek saati',
  'qr.unknownDevice': 'Bilinmeyen tarayıcı',
  'qr.phoneSafety': 'Yalnız kendi önündeki bilgisayarda, web.dijitalapp.com adresinde gördüğün kodu onayla. Biri sana bir QR kodu gönderip okutmanı istediyse onaylama: o kişi hesabına girer.',
  'qr.approve': 'Girişi onayla',
  'qr.decline': 'Reddet',
  'qr.approvedTitle': 'Bilgisayarında oturum açıldı',
  'qr.approvedBody': 'Bu oturumu istediğin zaman Ayarlar → Cihazlar’dan kapatabilirsin.',
  'qr.seeDevices': 'Cihazları gör',
  'qr.declinedTitle': 'Giriş reddedildi',
  'qr.errorTitle': 'Kod kullanılamadı',
  'qr.scan': 'QR kodu okut',
  'qr.scanHint': 'Bilgisayardaki DijitalApp giriş ekranında görünen kodu çerçeveye getir.',
  'qr.noScanner': 'Bu tarayıcı uygulama içinden QR okuyamıyor. Telefonunun kamera uygulamasını açıp bilgisayardaki koda tut; açılan bağlantı seni buraya getirir.',
  'qr.cameraDenied': 'Kameraya izin verilmedi. Tarayıcı ayarlarından kamera iznini aç ya da telefonunun kamera uygulamasıyla okut.',
  'qr.linkTitle': 'Bilgisayarda oturum aç',
  'qr.linkBody': 'Bilgisayarında web.dijitalapp.com’u aç, “Telefonla (QR)” sekmesindeki kodu buradan okut.',
  'qr.openOnPhone': 'Telefonda devam et',
  'qr.openOnPhoneBody': 'Kodu telefonunun kamerasıyla okut; kayıt telefonda açılır.',
  'assistant.title': 'DijitalApp Asistan',
  'assistant.entryBody': 'Kurumunuzun belgeleriyle yanıt veren, kaynak gösteren ve bilmediğini ekibinize devreden asistan.',
  'assistant.manage': 'Asistanı yönet',
  'assistant.backToSpace': 'Alana dön',
  'assistant.notAllowed': 'Bu alanın asistanını yalnız sahipleri ve yöneticileri, Business özelliği açıkken yönetebilir.',
  'assistant.on': 'Açık',
  'assistant.off': 'Kapalı',
  'assistant.stat.status': 'Durum',
  'assistant.stat.sources': 'Bilgi kaynağı',
  'assistant.stat.questions': 'Soru',
  'assistant.stat.unanswered': 'Yanıtlanamayan',
  'assistant.tab.sources': 'Bilgi kaynakları',
  'assistant.tab.test': 'Dene',
  'assistant.tab.settings': 'Ayarlar',
  'assistant.tab.unanswered': 'Yanıtlanamayanlar',
  'assistant.gettingStarted': 'Başlamak için önce Ayarlar’ı kaydedin, sonra metin, SSS ya da web sayfası ekleyin ve Dene sekmesinden sorular sorun.',
  'assistant.setupTitle': 'Sunucu kurulumu tamamlanmadı',
  'assistant.noAi': 'Yanıt üretimi kapalı: sunucuya Anthropic API anahtarı eklenince asistan yanıt vermeye başlar. O zamana kadar Dene sekmesi hangi kaynakların kullanılacağını gösterir.',
  'assistant.noEmbeddings': 'Anlamsal arama kapalı: Voyage AI anahtarı eklenince kaynaklar anlamına göre de aranır. Şimdilik kelime araması kullanılıyor; eklenen her şey anahtar gelince kendiliğinden işlenir.',
  'assistant.addSource': 'Bilgi kaynağı ekle',
  'assistant.saveSettingsFirst': 'Kaynak eklemeden önce Ayarlar sekmesinde asistanı bir kez kaydedin.',
  'assistant.sourceKind': 'Kaynak türü',
  'assistant.kind.text': 'Metin',
  'assistant.kind.faq': 'SSS',
  'assistant.kind.url': 'Web sayfası',
  'assistant.kindHint.text': 'Yönerge, duyuru, fiyat listesi gibi metinleri yapıştırın. Uzun metinler parçalara ayrılır.',
  'assistant.kindHint.faq': 'Soru–yanıt çiftleri. Her çift ayrı aranır, en isabetli sonuçları verir.',
  'assistant.kindHint.url': 'Herkese açık bir sayfanın metni okunur. Sayfa değişirse “Yeniden işle” deyin.',
  'assistant.url': 'Sayfa adresi',
  'assistant.sourceTitle': 'Başlık',
  'assistant.content': 'Metin',
  'assistant.question': 'Soru',
  'assistant.answer': 'Yanıt',
  'assistant.addPair': 'Soru ekle',
  'assistant.removePair': 'Bu soruyu kaldır',
  'assistant.add': 'Ekle ve işle',
  'assistant.indexing': 'İşleniyor…',
  'assistant.sources': 'Kaynaklar ({count})',
  'assistant.noSources': 'Henüz bilgi kaynağı yok.',
  'assistant.chunks': '{count} parça',
  'assistant.embedded': '{count} vektör',
  'assistant.status.ready': 'Hazır',
  'assistant.status.failed': 'Hata',
  'assistant.status.queued': 'Sırada',
  'assistant.reindex': 'Yeniden işle',
  'assistant.delete': 'Sil',
  'assistant.testTitle': '{name} ile deneyin',
  'assistant.testHint': 'Ziyaretçilerin kullanacağı akışın aynısı: yalnız eklediğiniz kaynaklardan yanıt verir ve kaynağını gösterir.',
  'assistant.newChat': 'Yeni sohbet',
  'assistant.thinking': 'Yanıt hazırlanıyor…',
  'assistant.retrievalOnly': 'Yanıt üretimi henüz kapalı. Bu soru için kullanılacak kaynaklar:',
  'assistant.handedOver': 'Ekibe devredildi',
  'assistant.askLabel': 'Bir soru yazın',
  'assistant.send': 'Gönder',
  'assistant.basics': 'Temel bilgiler',
  'assistant.behaviour': 'Davranış',
  'assistant.field.enabled': 'Asistan açık',
  'assistant.field.name': 'Asistanın adı',
  'assistant.field.tone': 'Üslup',
  'assistant.field.welcome': 'Karşılama mesajı',
  'assistant.field.handoffMessage': 'Devir mesajı',
  'assistant.field.blockedTopics': 'Girmeyeceği konular',
  'assistant.field.instructions': 'Ek talimatlar',
  'assistant.fieldHint.name': 'Ziyaretçiler bu adı görür.',
  'assistant.fieldHint.welcome': 'Sohbet açılınca gösterilir.',
  'assistant.fieldHint.handoffMessage': 'Yanıt kaynaklarda yoksa gösterilir; boş bırakılırsa standart mesaj kullanılır.',
  'assistant.fieldHint.blockedTopics': 'Virgülle ayırın; ör. siyaset, sağlık tavsiyesi. Bu konularda kibarca bir çalışana yönlendirir.',
  'assistant.fieldHint.instructions': 'Kurumunuza özel kurallar (ör. “Fiyat sorulursa güncel liste için mağazaya yönlendir”). Güvenlik ve kaynak kurallarını değiştiremez.',
  'assistant.tone.friendly': 'Samimi',
  'assistant.tone.formal': 'Resmî',
  'assistant.tone.concise': 'Kısa ve net',
  'assistant.save': 'Kaydet',
  'assistant.saved': 'Kaydedildi.',
  'assistant.unansweredHint': 'Asistanın kaynaklarda bulamadığı sorular. Bunlara yanıt veren bir SSS ekleyerek bilgi tabanınızı tamamlayın.',
  'assistant.noUnanswered': 'Yanıtlanamayan soru yok.',
  'assistant.times': '{count} kez',
  'admin.tab.appearance': 'Site görünümü',
  'appearance.defaultsLive': 'Varsayılan görünüm yayında (henüz değiştirilmedi)',
  'appearance.saved': 'Kaydedildi ve dijitalapp.com’da yayına alındı.',
  'appearance.restored': 'Seçilen sürüm geri yüklendi ve yayına alındı.',
  'appearance.theme': 'Hazır tema',
  'appearance.preset.clean': 'A · Sade / Kurumsal',
  'appearance.preset.warm': 'B · Sıcak / Aile odaklı',
  'appearance.preset.bold': 'C · Cesur / Teknoloji',
  'appearance.presetDesc.clean': 'Lacivert yazı, tek mavi vurgu, bol beyaz alan.',
  'appearance.presetDesc.warm': 'Krem zemin, kiremit ve yeşil, tırnaklı başlıklar.',
  'appearance.presetDesc.bold': 'Dev başlıklar, kalın çerçeveler, fosforlu yeşil.',
  'appearance.colours': 'Renkler',
  'appearance.coloursHint': 'Değiştirmediğin renkler temanın kendi rengini kullanır; koyu temada vurgu renkleri otomatik açılır.',
  'appearance.colour.accent': 'Vurgu rengi',
  'appearance.colour.secondary': 'İkinci renk',
  'appearance.colour.background': 'Zemin',
  'appearance.colour.text': 'Yazı',
  'appearance.custom': 'özel',
  'appearance.fromTheme': 'temadan',
  'appearance.useTheme': 'Temanın rengi',
  'appearance.shape': 'Yazı ve köşeler',
  'appearance.headingFont': 'Başlık yazı tipi',
  'appearance.font.preset': 'Temanın',
  'appearance.font.serif': 'Tırnaklı',
  'appearance.font.sans': 'Sade',
  'appearance.font.heavy': 'Kalın',
  'appearance.radius': 'Köşe yuvarlaklığı',
  'appearance.radiusOpt.preset': 'Temanın',
  'appearance.radiusOpt.sharp': 'Keskin',
  'appearance.radiusOpt.soft': 'Yumuşak',
  'appearance.radiusOpt.round': 'Yuvarlak',
  'appearance.hero': 'Giriş düzeni',
  'appearance.heroVisual': 'Görsel',
  'appearance.visual.preset': 'Temanın',
  'appearance.visual.phone': 'Telefon',
  'appearance.visual.desktop': 'Bilgisayar ekranı',
  'appearance.heroAlign': 'Yerleşim',
  'appearance.align.preset': 'Temanın',
  'appearance.align.split': 'Yan yana',
  'appearance.align.center': 'Ortalı',
  'appearance.order': 'Bölüm sırası',
  'appearance.orderHint': 'Giriş bölümü en üstte, kapanış ve alt bilgi en altta kalır. Bir bölümü gizlemek için Web sitesi sekmesini kullan.',
  'appearance.preview': 'Canlı önizleme',
  'appearance.unsaved': 'Kaydedilmedi',
  'appearance.device': 'Cihaz',
  'appearance.deviceOpt.desktop': 'Masaüstü',
  'appearance.deviceOpt.tablet': 'Tablet',
  'appearance.deviceOpt.phone': 'Telefon',
  'appearance.previewHint': 'Önizleme yalnız sana görünür; “Kaydet ve yayınla” deyince dijitalapp.com güncellenir.',
} satisfies Record<string, Entry>;

export type MessageKey = keyof typeof tr;
